import LangKeys from "./keys";

const te = {
  [LangKeys.reminders_collect_faster]: "3 రెట్లు వేగంగా చెల్లింపులను వసూలు చేయండి",
  [LangKeys.reminders_total_dues]: "మొత్తం బకాయిలు",
  [LangKeys.reminders_all_customers]: "అందరూ కస్టమర్లు",
  [LangKeys.reminders_all]: "అన్నీ",
  [LangKeys.reminders_customers]: "కస్టమర్లు",
  [LangKeys.reminders_suppliers]: "సప్లయర్లు",
  [LangKeys.reminders_search_placeholder]: "కస్టమర్ పేరు లేదా మొబైల్ నంబర్ శోధించండి...",
  [LangKeys.reminders_pending_balance]: "బకాయి మొత్తం",
  [LangKeys.reminders_sent]: "పంపబడింది",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "కాల్ చేయండి",
  [LangKeys.reminders_date]: "తేదీ",
  [LangKeys.reminders_all_up_to_date]: "అన్నీ అప్‌డేట్‌గా ఉన్నాయి",
  [LangKeys.reminders_no_overdue_heading]: "గడువు ముగిసిన కస్టమర్లు ఎవరూ లేరు",
  [LangKeys.reminders_no_overdue_sub]: "గొప్పది! కస్టమర్ల బకాయిలన్నీ సమయానికి ఉన్నాయి.",
  [LangKeys.reminders_view_all_customers]: "అందరూ కస్టమర్లను చూడండి",
  [LangKeys.reminders_no_due_today_heading]: "ఈరోజు గడువు ఉన్న కస్టమర్లు ఎవరూ లేరు",
  [LangKeys.reminders_no_due_today_sub]: "ఈరోజుకు ఎటువంటి చెల్లింపు రిమైండర్‌లు లేవు.",
  [LangKeys.reminders_no_upcoming_heading]: "రాబోయే రిమైండర్‌లు ఏవీ లేవు",
  [LangKeys.reminders_no_upcoming_sub]: "సకాలంలో రిమైండర్‌లను పంపడానికి వసూలు తేదీని సెట్ చేయండి.",
  [LangKeys.reminders_no_customers_found]: "కస్టమర్లు ఎవరూ కనుగొనబడలేదు",
  [LangKeys.reminders_no_customers_matched]: "మీ శోధనకు సరిపోలే కస్టమర్లు ఎవరూ లేరు.",
  [LangKeys.reminders_auto_reminder_active]: "ఆటో రిమైండర్ సక్రియంగా ఉంది",
  [LangKeys.reminders_overdue_by]: "గడువు ముగిసింది",
  [LangKeys.reminders_due_in]: "మిగిలిన రోజులు",
  [LangKeys.reminders_days]: "రోజులు",
  [LangKeys.reminders_day]: "రోజు",
  [LangKeys.reminders_set_collection_date]: "వసూలు తేదీని సెట్ చేయండి",
  [LangKeys.reminders_collect_faster_sub]: "కస్టమర్ల నుండి వేగంగా వసూలు చేయండి",
  [LangKeys.reminders_pending_amount_filter]: "బకాయి మొత్తం ఫిల్టర్ (₹)",
  [LangKeys.reminders_highest_amount]: "అత్యధిక మొత్తం",
  [LangKeys.reminders_oldest_dues]: "పురాతన బకాయిలు",
  [LangKeys.reminders_by_due_date]: "గడువు తేదీ ప్రకారం",
  [LangKeys.reminders_min]: "కనిష్ట",
  [LangKeys.reminders_max]: "గరిష్ట",
  [LangKeys.reminders_to]: "వరకు",
  [LangKeys.reminders_customers_selected]: "కస్టమర్లు ఎంపిక చేయబడ్డారు",
  [LangKeys.reminders_total]: "మొత్తం",
  [LangKeys.reminders_set_due_date_selected]: "ఎంచుకున్న వారికి గడువు తేదీని సెట్ చేయండి",
  [LangKeys.reminders_date_lbl]: "తేదీ",
  [LangKeys.reminders_wa_sent_toast]: "{name}కి WhatsApp రిమైండర్ పంపబడింది!",
  [LangKeys.reminders_date_updated]: "రిమైండర్ తేదీ విజయవంతంగా సేవ్ చేయబడింది!",

  [LangKeys.reminders_bulk_success]: "రిమైండర్లు విజయవంతంగా పంపబడ్డాయి!",

  [LangKeys.reminders_sending]: "సేవ్ అవుతోంది...",

  [LangKeys.reminders_cloud_wa]: "క్లౌడ్ WhatsApp API",

  [LangKeys.reminders_direct_wa]: "ప్రత్యక్ష WhatsApp (ఉచిత వెబ్/యాప్)",

  [LangKeys.reminders_no_pending_desc]: "వినియోగదారుడి నుండి డబ్బులు రావాల్సి ఉన్నప్పుడు, వారు ఇక్కడ రిమైండర్ల జాబితాలో కనిపిస్తారు.",

  [LangKeys.reminders_no_pending]: "పెండింగ్ రిమైండర్‌లు ఏవీ లేవు",

  [LangKeys.reminders_clear_date]: "తేదీని తీసివేయండి",

  [LangKeys.reminders_save_date]: "తేదీని సేవ్ చేయండి",

  [LangKeys.reminders_time_lbl]: "సమయం",

  [LangKeys.reminders_chip_custom]: "అనుకూల తేదీ",

  [LangKeys.reminders_chip_1month]: "1 నెల తర్వాత",

  [LangKeys.reminders_chip_15days]: "15 రోజుల తర్వాత",

  [LangKeys.reminders_chip_1week]: "1 వారం తర్వాత",

  [LangKeys.reminders_chip_3days]: "3 రోజుల తర్వాత",

  [LangKeys.reminders_chip_tomorrow]: "రేపు",

  [LangKeys.reminders_chip_today]: "ఈరోజు",

  [LangKeys.reminders_days_left]: "రోజులు మిగిలి ఉన్నాయి",

  [LangKeys.reminders_days_overdue]: "రోజులు ఆలస్యం",

  [LangKeys.reminders_not_sent]: "ఇంకా పంపబడలేదు",

  [LangKeys.reminders_last_sent]: "చివరిసారి పంపబడింది",

  [LangKeys.reminders_auto_reminder_desc]: "షెడ్యూల్ చేసిన తేదీ మరియు సమయంలో ఆటోమేటిక్‌గా రిమైండర్ పంపండి",

  [LangKeys.reminders_auto_reminder]: "ఆటో రిమైండర్ (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "అందరికీ ఒకేసారి వాట్సాప్ పంపండి",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp రిమైండర్ పంపండి",

  [LangKeys.reminders_change_due_date]: "తేదీని మార్చండి",

  [LangKeys.reminders_set_due_date]: "గడువు తేదీని సెట్ చేయండి",

  [LangKeys.reminders_selected]: "ఎంచుకోబడినవి",

  [LangKeys.reminders_select_all]: "అన్నీ ఎంచుకోండి",

  [LangKeys.reminders_search_hint]: "వినియోగదారు పేరు లేదా మొబైల్ నంబర్‌ను శోధించండి...",

  [LangKeys.reminders_no_date_tab]: "తేదీ లేదు",

  [LangKeys.reminders_upcoming_tab]: "రాబోయేవి",

  [LangKeys.reminders_overdue_tab]: "ఓవర్‌డ్యూ",

  [LangKeys.reminders_today_tab]: "ఈరోజు",

  [LangKeys.reminders_all_tab]: "అన్నీ",

  [LangKeys.reminders_no_date]: "తేదీ లేదు",

  [LangKeys.reminders_upcoming]: "రాబోయేవి",

  [LangKeys.reminders_due_today]: "ఈరోజు గడువు",

  [LangKeys.reminders_overdue]: "గడువు ముగిసినవి",

  [LangKeys.reminders_total_outstanding]: "మొత్తం బకాయి",

  [LangKeys.reminders_subtitle]: "స్మార్ట్ బుక్ కీపింగ్ తో మీ వ్యాపారాన్ని పెంచుకోండి.",

  [LangKeys.reminders_title]: "చెల్లింపు రిమైండర్",

  [LangKeys.processing]: "ప్రాసెసింగ్ జరుగుతోంది...",

  [LangKeys.business_owner]: "వ్యాపార యజమాని",

  [LangKeys.moxpal_khata]: "మోక్స్‌పాల్ ఖాతా",

  [LangKeys.failed_load_dashboard]: "డ్యాష్‌బోర్డ్ డేటాను లోడ్ చేయడంలో విఫలమైంది",

  [LangKeys.delete_confirm]: "మీరు ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?",

  [LangKeys.today]: "ఈరోజు",

  [LangKeys.add_bill_terms_conditions_hint]: "నిబంధనలు మరియు షరతులు...",

  [LangKeys.stock]: "స్టాక్",

  [LangKeys.add_bill_item_price]: "ధర",

  [LangKeys.add_bill_item_name]: "వస్తువు పేరు",

  [LangKeys.parties]: "పార్టీలు",

  [LangKeys.address_area]: "ప్రాంతం / ల్యాండ్‌మార్క్",

  [LangKeys.address_flat_no]: "ఫ్లాట్ / బిల్డింగ్ నెం.",

  [LangKeys.search_items_hint]: "వస్తువులను శోధించండి...",

  [LangKeys.no_items_found]: "వస్తువులు ఏవీ కనుగొనబడలేదు",

  [LangKeys.loading]: "లోడ్ అవుతోంది...",

  [LangKeys.edit_price_dialog_title]: "ధరను సవరించండి",

  [LangKeys.photos]: "ఫోటోలు",

  [LangKeys.notes]: "గమనికలు",

  [LangKeys.save_expense]: "ఖర్చును సేవ్ చేయండి",

  [LangKeys.add_bill_payment_details]: "చెల్లింపు వివరాలు",

  [LangKeys.fields]: "ఫీల్డ్లు",

  [LangKeys.unpaid]: "చెల్లించనిది (Unpaid)",

  [LangKeys.item_name_required]: "వస్తువు పేరు అవసరం",

  [LangKeys.delete_confirmation]: "మీరు ఖచ్చితంగా దీన్ని తొలగించాలనుకుంటున్నారా?",

  [LangKeys.online_private]: "ప్రైవేట్ (Private)",

  [LangKeys.online_active]: "ఆన్‌లైన్ మార్కెట్‌లో అందుబాటులో ఉంది",

  [LangKeys.app_name]: "మోక్ష్‌పాల్ ఖాతా",
  [LangKeys.header_subtitle]: "స్మార్ట్ బుక్‌కీపింగ్‌తో మీ వ్యాపారాన్ని అభివృద్ధి చేసుకోండి.",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: "ఖాతా సారాంశం",
  [LangKeys.customer_name]: "వినియోగదారుడి పేరు",
  [LangKeys.mobile_no]: "మొబైల్ నంబర్",
  [LangKeys.transaction_history]: "లావాదేవీల చరిత్ర",
  [LangKeys.total_debit]: "మొత్తం డెబిట్",
  [LangKeys.total_credit]: "మొత్తం క్రెడిట్",
  [LangKeys.net_balance]: "నికర బ్యాలెన్స్",
  [LangKeys.date]: "తేదీ",
  [LangKeys.credit]: "క్రెడిట్",
  [LangKeys.debit]: "డెబిట్",
  [LangKeys.balance]: "బ్యాలెన్స్",
  [LangKeys.note]: "గమనిక",
  [LangKeys.call_support]: "మద్దతుకు కాల్ చేయండి",
  [LangKeys.invalid_link]: "ఈ లింక్ చెల్లదు లేదా గడువు ముగిసింది.",
  [LangKeys.footer]: "ఇది కంప్యూటర్ ద్వారా రూపొందించబడిన ప్రకటన మరియు దీనికి ఎలాంటి సంతకం అవసరం లేదు.",

  // COMMON
  [LangKeys.settings]: "సెట్టింగ్‌లు",
  [LangKeys.settings_subtitle]: "మీ అప్లికేషన్ మరియు వ్యాపార ప్రాధాన్యతలను నిర్వహించండి",
  [LangKeys.language]: "భాష",
  [LangKeys.select_language]: "భాషను ఎంచుకోండి",
  [LangKeys.close]: "మూసివేయండి",
  [LangKeys.save]: "సేవ్ చేయండి",
  [LangKeys.retry]: "మళ్ళీ ప్రయత్నించండి",
  [LangKeys.profile]: "ప్రొఫైల్‌ను సవరించండి",
  [LangKeys.logout]: "లాగ్అవుట్",
  [LangKeys.version]: "వెర్షన్",
  [LangKeys.copyright]: "కాపీరైట్ © మోక్స్‌పాల్ ఖాతా",
  [LangKeys.total]: "మొత్తం",
  [LangKeys.required_field]: "ఈ ఫీల్డ్ తప్పనిసరి",
  [LangKeys.product]: "ఉత్పత్తి",

  [LangKeys.message_language]: "SMS భాష",
  [LangKeys.follow_app]: "యాప్‌ను అనుసరించండి",

  [LangKeys.hindi]: "హిందీ",
  [LangKeys.english]: "ఇంగ్లీష్",
  [LangKeys.hinglish]: "హింగ్లిష్",

  [LangKeys.gujarati]: "గుజరాతీ",
  [LangKeys.marathi]: "మరాఠీ",
  [LangKeys.punjabi]: "పంజాబీ",
  [LangKeys.tamil]: "తమిళం",
  [LangKeys.telugu]: "తెలుగు",

  // SETTINGS PAGE
  [LangKeys.business_settings]: "వ్యాపార సెట్టింగ్‌లు",
  [LangKeys.business_settings_desc]: "వ్యాపార ప్రొఫైల్, లోగో & GST వివరాలు",
  [LangKeys.staff_permissions]: "సిబ్బంది & అనుమతులు",
  [LangKeys.staff_permissions_desc]: "సిబ్బంది యాక్సెస్ మరియు అనుమతులను నిర్వహించండి",
  [LangKeys.backup_information]: "బ్యాకప్ సమాచారం",
  [LangKeys.backup_information_desc]: "ఖాతా డేటాను ఎగుమతి చేయండి మరియు పునరుద్ధరించండి",
  [LangKeys.delete_khata]: "ఖాతాను తొలగించండి",
  [LangKeys.delete_khata_desc]: "అన్ని వ్యాపార డేటాను శాశ్వతంగా తొలగించండి",
  [LangKeys.app_update]: "యాప్ అప్‌డేట్",
  [LangKeys.app_update_desc]: "తాజా వెర్షన్ కోసం తనిఖీ చేయండి",
  [LangKeys.app_up_to_date]: "యాప్ తాజా వెర్షన్‌లో ఉంది",
  [LangKeys.failed_to_check_for_update]: "అప్‌డేట్‌ను తనిఖీ చేయడంలో విఫలమైంది",
  [LangKeys.whatsapp_service]: "వాట్సాప్ అలర్ట్స్ & క్రెడిట్స్",
  [LangKeys.whatsapp_service_desc]: "గ్రాహకులకు ఆటోమేటిక్ చెల్లింపు రిమైండర్లు పంపి క్రెడిట్స్‌ను నిర్వహించండి",

  /* ================= Whatsapp SMS Credtits PAGE ================= */
  [LangKeys.whatsapp_credits]: "వాట్సాప్ క్రెడిట్స్",
  [LangKeys.available_credits]: "లభ్యమైన క్రెడిట్స్",
  [LangKeys.whatsapp_balance]: "వాట్సాప్ సందేశ బ్యాలెన్స్",
  [LangKeys.used]: "వినియోగం",
  [LangKeys.credits]: "క్రెడిట్స్",
  [LangKeys.proceed_to_pay]: "చెల్లించండి",
  [LangKeys.recharge_plans]: "రిచార్జ్ ప్లాన్లు",
  [LangKeys.off]: "ఆఫ్",

  [LangKeys.load_failed]: "లోడ్ విఫలమైంది",
  [LangKeys.toggle_failed]: "టాగుల్ విఫలమైంది",
  [LangKeys.order_failed]: "ఆర్డర్ విఫలమైంది",
  [LangKeys.payment_error]: "చెల్లింపు లోపం",
  [LangKeys.payment_failed]: "చెల్లింపు విఫలమైంది",
  [LangKeys.verification_failed]: "ధృవీకరణ విఫలమైంది",
  [LangKeys.recharge_successful]: "రిచార్జ్ విజయవంతంగా పూర్తైంది",
  [LangKeys.total_purchased]: "మొత్తం కొనుగోలు చేసినవి",
  [LangKeys.premium_unlimited_active]: "అపరిమిత WhatsApp అలర్ట్లు సక్రియంగా ఉన్నాయి! 🎉",
  [LangKeys.premium_unlimited_desc]: "మీరు Moxpal Khata యొక్క ఉత్తమ 'Premium Plan' యొక్క సక్రియ సభ్యులు! మీకు అపరిమిత ఆటో WhatsApp మరియు SMS అలర్ట్లు పూర్తిగా ఉచితంగా అందించబడ్డాయి.",

  /* ================= BACKUP INFORMATION ================= */
  [LangKeys.backup_info_text]: "మీ ఫోన్ ఇంటర్నెట్‌కు కనెక్ట్ చేయబడినప్పుడు మీ డేటా స్వయంచాలకంగా బ్యాకప్ చేయబడుతుంది. మీరు మీ ఫోన్‌ను ఫార్మాట్ చేస్తే లేదా యాప్‌ను తొలగిస్తే, మీ రిజిస్టర్డ్ నంబర్‌ని ఉపయోగించి మళ్లీ లాగిన్ అవ్వండి. మీ డేటా స్వయంచాలకంగా పునరుద్ధరించబడుతుంది.",
  [LangKeys.last_backup_at]: "చివరి బ్యాకప్",

  /* ================= DELETE / KHATA ================= */
  [LangKeys.delete_warning_text]: "మీరు ఈ వ్యాపారాన్ని తొలగించబోతున్నారు. మీ మొత్తం డేటా రీసైకిల్ బిన్‌కు తరలించబడుతుంది. మీరు దాన్ని 30 రోజుల్లోగా పునరుద్ధరించవచ్చు.",
  [LangKeys.delete_placeholder]: "నిర్ధారించడానికి వ్యాపార పేరును టైప్ చేయండి",
  [LangKeys.delete_button]: "తొలగించండి",
  [LangKeys.delete_name_mismatch]: "వ్యాపార పేరు సరిపోలడం లేదు.",

  // ================= KHATA =================
  [LangKeys.my_khata]: "నా ఖాతా",
  [LangKeys.search_customer]: "గ్రాహకుడిని వెతకండి",
  [LangKeys.all_customers]: "అన్ని గ్రాహకులు",
  [LangKeys.no_customers_found]: "ఎలాంటి గ్రాహకులు కనబడలేదు",
  [LangKeys.no_suppliers_found]: "ఎలాంటి సరఫరాదారులు కనబడలేదు",
  [LangKeys.no_parties_found]: "ఏ పక్షాలు కనబడలేదు",

  [LangKeys.just_now]: "ఇప్పుడే",
  [LangKeys.min_ago]: "{value} నిమిషాల క్రితం",
  [LangKeys.hr_ago]: "{value} గంటల క్రితం",
  [LangKeys.day_ago]: "{value} రోజుల క్రితం",
  [LangKeys.month_ago]: "{value} నెలల క్రితం",
  [LangKeys.year_ago]: "{value} సంవత్సరాల క్రితం",

  [LangKeys.settled]: "హిసాబు సరి",
  [LangKeys.due]: "ఉధార",
  [LangKeys.no_transactions]: "లావాదేవీలు లేవు",
  [LangKeys.no_entries_yet]: "ఇంకా ఎలాంటి నమోదు లేదు",
  [LangKeys.new_label]: "కొత్తది",

  /* ================= DASHBOARD / HOME SCREEN ================= */
  [LangKeys.khata]: "ఖాతా",
  [LangKeys.you_will_get]: "మీరు పొందుతారు",
  [LangKeys.you_will_give]: "మీరు ఇస్తారు",
  [LangKeys.search_khata_entry]: "ఖాతా ఎంట్రీని శోధించండి",
  [LangKeys.recent_entries]: "ఇటీవలి ఎంట్రీలు",
  [LangKeys.unknown_party]: "తెలియని పార్టీ",
  [LangKeys.unknown_customer]: "తెలియని వినియోగదారు",
  [LangKeys.unknown]: "తెలియని",

  // CUSTOMER LEDGER
  [LangKeys.ledger]: "ఖాతా పుస్తకం",
  [LangKeys.report]: "నివేదిక",
  [LangKeys.reminder]: "జ్ఞాపిక",
  [LangKeys.sms]: "ఎస్ఎంఎస్",
  [LangKeys.whatsapp]: "వాట్సాప్",
  [LangKeys.outstanding_balance]: "బకాయి మొత్తం",
  [LangKeys.total_balance]: "మొత్తం బ్యాలెన్స్",
  [LangKeys.you_got]: "మీరు పొందారు",
  [LangKeys.you_gave]: "మీరు ఇచ్చారు",
  [LangKeys.entries]: "ఎంట్రీలు",
  [LangKeys.no_entries_found]: "ఎంట్రీలు ఏవీ కనుగొనబడలేదు",
  [LangKeys.i_got]: "నేను పొందాను",
  [LangKeys.i_gave]: "నేను ఇచ్చాను",
  [LangKeys.you_got_caps]: "మీరు పొందారు",
  [LangKeys.you_gave_caps]: "మీరు ఇచ్చారు",
  [LangKeys.wa_dear]: "ప్రియమైన",
  [LangKeys.wa_account_update]: "మోక్ష్‌పాల్ ఖాతా నుండి మీ ఖాతా నవీకరణ ఇక్కడ ఉంది.",
  [LangKeys.total_due]: "మొత్తం బాకీ మొత్తం",
  [LangKeys.view_full_account]: "పూర్తి ఖాతా స్టేట్‌మెంట్‌ను వీక్షించండి",
  [LangKeys.failed_to_load_data]: "డేటాను లోడ్ చేయడంలో విఫలమైంది.",
  [LangKeys.could_not_open_whatsapp]: "వాట్సాప్‌ను తెరవలేకపోయింది.",
  [LangKeys.could_not_open_sms]: "SMS యాప్‌ను తెరవలేకపోయింది.",
  [LangKeys.total_purchase]: "మొత్తం కొనుగోలు",
  [LangKeys.total_received]: "మొత్తం పొందిన",

  [LangKeys.entry_success]: "ఎంట్రీ విజయవంతంగా పూర్తైంది",
  [LangKeys.transaction_success]: "లావాదేవీ విజయవంతంగా పూర్తైంది",
  [LangKeys.done]: "పూర్తైంది",

  // ENTRY
  [LangKeys.entry_details]: "ఎంట్రీ వివరాలు",
  [LangKeys.running_balance]: "నడుస్తున్న బ్యాలెన్స్",
  [LangKeys.share]: "షేర్ చేయండి",
  [LangKeys.network_error]: "నెట్‌వర్క్ లోపం",
  [LangKeys.copy_link]: "లింక్‌ను కాపీ చేయండి",
  [LangKeys.delete_entry]: "ఎంట్రీని తొలగించండి",
  [LangKeys.delete_entry_confirm]: "మీరు ఈ ఎంట్రీని నిజంగా తొలగించాలనుకుంటున్నారా?",
  [LangKeys.delete_entry_warning]: "ఈ చర్యను అన్డు చేయలేరు.",
  [LangKeys.edit_entry]: "ఎంట్రీని సవరించండి",
  [LangKeys.invalid_entry]: "చెల్లని ఎంట్రీ",
  [LangKeys.entry_not_found]: "ఎంట్రీ కనుగొనబడలేదు",
  [LangKeys.invalid_entry_type]: "చెల్లని ఎంట్రీ రకం",
  [LangKeys.invalid_amount]: "చెల్లని మొత్తం",
  [LangKeys.invalid_date]: "చెల్లని తేదీ",
  [LangKeys.photo_size_error]: "ఫోటో పరిమాణం 1MB కన్నా తక్కువ ఉండాలి",
  [LangKeys.invalid_image_format]: "ఈ ఫోటో ఫార్మాట్ సపోర్ట్ చేయబడదు. దయచేసి JPG, PNG లేదా WEBP ఫోటోను ఎంచుకోండి.",
  [LangKeys.photo_upload_failed]: "ఫోటో అప్‌లోడ్ విఫలమైంది",
  [LangKeys.update_failed]: "నవీకరణ విఫలమైంది",
  [LangKeys.amount]: "మొత్తం",
  [LangKeys.photo_max]: "ఫోటో (గరిష్టంగా 1MB)",
  [LangKeys.change_photo]: "ఫోటోను మార్చండి",
  [LangKeys.add_entry_title]: "ఎంట్రీని జోడించండి",
  [LangKeys.save_entry]: "ఎంట్రీని సేవ్ చేయండి",
  [LangKeys.photo]: "ఫోటో",
  [LangKeys.amount_hint]: "₹ 0",
  [LangKeys.note_hint]: "ఐచ్ఛిక గమనిక",
  [LangKeys.add_photo_label]: "📷 ఫోటోను జోడించండి",
  [LangKeys.failed_to_add_entry]: "ఎంట్రీని జోడించడంలో విఫలమైంది.",
  [LangKeys.image_too_large_4mb]: "చిత్రం చాలా పెద్దది. దయచేసి 4MB కన్నా తక్కువ ఉన్న చిత్రాన్ని ఎంచుకోండి.",
  [LangKeys.share_coming_soon]: "షేర్ ఫీచర్ త్వరలో వస్తుంది!",
  [LangKeys.image_load_failed]: "చిత్రాన్ని లోడ్ చేయడంలో విఫలమైంది",
  [LangKeys.select_date]: "తేదీని ఎంచుకోండి",
  [LangKeys.photo_max_2mb]: "ఫోటో (గరిష్టంగా 2MB)",
  [LangKeys.add_to_cashbook]: "క్యాష్‌బుక్‌లో కూడా జోడించండి",

  // PDF
  [LangKeys.owner_name]: "యజమాని పేరు",
  [LangKeys.customer_ledger_statement]: "వినియోగదారు ఖాతా పుస్తకం స్టేట్‌మెంట్",
  [LangKeys.phone]: "ఫోన్",
  [LangKeys.opening_balance]: "ప్రారంభ బ్యాలెన్స్",
  [LangKeys.closing_balance]: "ముగింపు బ్యాలెన్స్",
  [LangKeys.transaction_details]: "లావాదేవీ వివరాలు",
  [LangKeys.particulars]: "వివరాలు",
  [LangKeys.credit_short]: "క్రె",
  [LangKeys.debit_short]: "డె",
  [LangKeys.generated_by]: "మోక్ష్‌పాల్ ఖాతా ద్వారా రూపొందించబడింది",
  [LangKeys.my_business]: "నా వ్యాపారం",
  [LangKeys.pdf_generation_error]: "PDFని రూపొందించడంలో లోపం",
  [LangKeys.debit_minus]: "డెబిట్ (-)",
  [LangKeys.credit_plus]: "క్రెడిట్ (+)",
  [LangKeys.total_paid]: "మొత్తం చెల్లించిన మొత్తం",
  [LangKeys.received]: "అందుకున్నది",
  [LangKeys.paid]: "చెల్లింపు",
  [LangKeys.supplier_name]: "సరఫరాదారు పేరు",
  [LangKeys.supplier_report]: "సరఫరాదారు నివేదిక",
  [LangKeys.supplier_ledger_statement]: "సరఫరాదారు లెడ్జర్ స్టేట్‌మెంట్",
  [LangKeys.data_not_available_for_pdf]: "PDF కోసం డేటా అందుబాటులో లేదు",

  // ACCOUNT
  [LangKeys.account]: "ఖాతా",
  [LangKeys.add_business]: "వ్యాపార వివరాలను జోడించండి",
  [LangKeys.add_owner]: "యజమాని వివరాలను జోడించండి",
  [LangKeys.business]: "వ్యాపారం",
  [LangKeys.staff]: "సిబ్బంది",
  [LangKeys.items]: "వస్తువులు",
  [LangKeys.bills]: "బిల్లులు",
  [LangKeys.dairy]: "డెయిరీ",
  [LangKeys.cashbook]: "క్యాష్‌బుక్",
  [LangKeys.help_support]: "సహాయం & మద్దతు",
  [LangKeys.about_app]: "మా గురించి",
  [LangKeys.invite_friends]: "స్నేహితులను ఆహ్వానించండి",
  [LangKeys.privacy_policy]: "గోప్యతా విధానం",
  [LangKeys.disclaimer]: "నిరాకరణ",
  [LangKeys.share_subject]: "📒 మోక్స్పాల్ ఖాతా యాప్",
  [LangKeys.share_message]: "👉 అప్పులు మరియు లావాదేవీల ఖాతాలను నిర్వహించడానికి నేను Moxpal Khata యాప్ ఉపయోగిస్తున్నాను. ఇది చాలా సులభమైన మరియు నమ్మకమైన యాప్. 📲 మీరు కూడా ఇప్పుడే డౌన్‌లోడ్ చేసి మీ ఖాతాలను సులభంగా నిర్వహించండి: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: "సిబ్బంది వివరాలు",
  [LangKeys.staff_question]: "సిబ్బంది అంటే ఏమిటి?",
  [LangKeys.add_staff]: "సిబ్బందిని జోడించండి",
  [LangKeys.staff_name]: "సిబ్బంది పేరు",
  [LangKeys.permissions]: "అనుమతులు",
  [LangKeys.stop_staff]: "సిబ్బందిని ఆపండి",
  [LangKeys.stop_staff_desc]: "ఈ సిబ్బంది మీ వ్యాపార డేటాను యాక్సెస్ చేయలేరు.",
  [LangKeys.delete_staff]: "సిబ్బందిని తొలగించండి",
  [LangKeys.delete_staff_desc]: "ఈ సిబ్బంది శాశ్వతంగా తొలగించబడతారు.",
  [LangKeys.add_staff_to_manage]: "నిర్వహణ కోసం సిబ్బందిని జోడించండి",

  // NAVBAR
  [LangKeys.home]: "హోమ్",
  [LangKeys.more]: "మరింత",

  // ADD PARTY
  [LangKeys.add_party]: "పార్టీని జోడించండి",
  [LangKeys.address_optional]: "చిరునామా (ఐచ్ఛికం)",
  [LangKeys.gst_optional]: "GSTIN (ఐచ్ఛికం)",
  [LangKeys.add_supplier]: "సరఫరాదారుని జోడించండి",
  [LangKeys.name_required]: "పేరు అవసరం",
  [LangKeys.edit]: "సవరించండి",

  // BOOK PROFILE
  [LangKeys.book_profile]: "ఖాతా ప్రొఫైల్ సృష్టించండి",
  [LangKeys.personal_info]: "వ్యక్తిగత సమాచారం",
  [LangKeys.business_info]: "వ్యాపార సమాచారం",
  [LangKeys.financial_info]: "ఆర్థిక సమాచారం",
  [LangKeys.staff_info]: "సిబ్బంది సమాచారం",
  [LangKeys.name]: "పేరు",
  [LangKeys.add_name]: "పేరును జోడించండి",
  [LangKeys.registered_number]: "రిజిస్టర్డ్ మొబైల్ నంబర్",
  [LangKeys.add_mobile]: "మొబైల్ నంబర్‌ను జోడించండి",
  [LangKeys.business_name]: "వ్యాపార పేరు",
  [LangKeys.business_address]: "వ్యాపార చిరునామా",
  [LangKeys.add_address]: "చిరునామాను జోడించండి",
  [LangKeys.gstin]: "GSTIN",
  [LangKeys.bank_account]: "బ్యాంక్ ఖాతా",
  [LangKeys.add_details]: "వివరాలను జోడించండి",
  [LangKeys.details]: "వివరాలు",
  [LangKeys.add_photo]: "ఫోటో జోడించండి",
  [LangKeys.profile_strength]: "ప్రొఫైల్ బలం",
  [LangKeys.customer_profile]: "గ్రాహక ప్రొఫైల్",
  [LangKeys.supplier_profile]: "సరఫరాదారు ప్రొఫైల్",
  [LangKeys.address]: "చిరునామా",
  [LangKeys.type]: "రకం",
  [LangKeys.customer]: "గ్రాహకుడు",
  [LangKeys.supplier]: "సరఫరాదారు",
  [LangKeys.delete_customer]: "గ్రాహకుడిని తొలగించండి",
  [LangKeys.delete_supplier]: "సరఫరాదారుని తొలగించండి",
  [LangKeys.delete_customer_desc]: "ఈ గ్రాహకుడిని తొలగించాలనుకుంటున్నారా? దీనికి సంబంధించిన మొత్తం డేటా తొలగించబడుతుంది.",
  [LangKeys.delete_supplier_desc]: "ఈ సరఫరాదారుని తొలగించాలనుకుంటున్నారా? దీనికి సంబంధించిన మొత్తం డేటా తొలగించబడుతుంది.",
  [LangKeys.add_gstin]: "GSTIN జోడించండి",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.sms_settings]: "SMS సెట్టింగులు",
  [LangKeys.sms_settings_desc]: "ఈ కస్టమర్ కోసం మెసేజ్ సెట్టింగులను నిర్వహించండి",

  [LangKeys.edit_customer_details]: "కస్టమర్ వివరాలను సవరించండి",
  [LangKeys.edit_customer_details_desc]: "ఇక్కడ మీరు పేరు, మొబైల్, చిరునామా మరియు GST వివరాలను మార్చవచ్చు.",

  // PROFILE STRENGTH
  [LangKeys.weak]: "బలహీనమైనది",
  [LangKeys.average]: "సగటు",
  [LangKeys.good]: "మంచిది",
  [LangKeys.strong]: "బలమైనది",

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: "సిబ్బందిని సేవ్ చేయండి",
  [LangKeys.update_staff]: "సిబ్బందిని నవీకరించండి",
  [LangKeys.cancel]: "రద్దు చేయండి",
  [LangKeys.no_staff_found]: "సిబ్బంది ఎవరూ కనుగొనబడలేదు",
  [LangKeys.active]: "క్రియాశీలకం",
  [LangKeys.stopped]: "ఆపివేయబడింది",
  [LangKeys.start]: "ప్రారంభించండి",
  [LangKeys.stop]: "ఆపండి",
  [LangKeys.view]: "వీక్షించండి",
  [LangKeys.add]: "జోడించండి",
  [LangKeys.delete]: "తొలగించండి",
  [LangKeys.mobile_number]: "మొబైల్ నంబర్",
  [LangKeys.add_staff_title]: "సిబ్బందిని జోడించండి",
  [LangKeys.edit_staff_title]: "సిబ్బందిని సవరించండి",
  [LangKeys.staff_deleted_success]: "సిబ్బంది విజయవంతంగా తొలగించబడ్డారు",
  [LangKeys.yes]: "అవును",
  [LangKeys.no]: "కాదు",
  [LangKeys.khatabook_deleted_success]: "ఖాతా పుస్తకం విజయవంతంగా తొలగించబడింది",
  [LangKeys.something_went_wrong]: "ఏదో తప్పు జరిగింది",
  [LangKeys.business_logo]: "వ్యాపార లోగో",
  [LangKeys.choose_photo]: "ఫోటోను ఎంచుకోండి",
  [LangKeys.save_logo]: "లోగోను సేవ్ చేయండి",
  [LangKeys.upload_error]: "అప్‌లోడ్ లోపం",
  [LangKeys.upload_type_err]: "అప్‌లోడ్ రకం లోపం",
  [LangKeys.enter_name]: "పేరును నమోదు చేయండి",
  [LangKeys.enter_mobile]: "మొబైల్‌ను నమోదు చేయండి",
  [LangKeys.enter_business]: "వ్యాపారాన్ని నమోదు చేయండి",
  [LangKeys.enter_address]: "చిరునామాను నమోదు చేయండి",
  [LangKeys.gstin_details]: "GSTIN వివరాలు",
  [LangKeys.gstin_number]: "GSTIN నంబర్",
  [LangKeys.enter_gstin]: "GSTIN నమోదు చేయండి",
  [LangKeys.gstin_note]: "మీ GSTIN మీ వ్యాపారాన్ని ధృవీకరించడానికి మరియు ఇన్‌వాయిస్‌లను రూపొందించడానికి ఉపయోగించబడుతుంది.",
  [LangKeys.save_gstin]: "GSTIN సేవ్ చేయండి",
  [LangKeys.bank_details]: "బ్యాంక్ వివరాలు",
  [LangKeys.bank_name]: "బ్యాంక్ పేరు",
  [LangKeys.enter_bank_name]: "బ్యాంక్ పేరును నమోదు చేయండి",
  [LangKeys.account_number]: "ఖాతా సంఖ్య",
  [LangKeys.enter_account_no]: "ఖాతా సంఖ్యను నమోదు చేయండి",
  [LangKeys.ifsc_code]: "IFSC కోడ్",
  [LangKeys.enter_ifsc]: "IFSC కోడ్‌ను నమోదు చేయండి",
  [LangKeys.bank_note]: "మీ బ్యాంక్ ఖాతా చెల్లింపులను స్వీకరించడానికి ఉపయోగించబడుతుంది.",
  [LangKeys.save_bank_details]: "బ్యాంక్ వివరాలను సేవ్ చేయండి",
  [LangKeys.invalid_bank_details]: "చెల్లని బ్యాంక్ వివరాలు",
  [LangKeys.confirm]: "నిర్ధారించండి",
  [LangKeys.invalid_gstin]: "చెల్లని GSTIN",
  [LangKeys.failed_to_save]: "సేవ్ చేయడంలో విఫలమైంది",

  // Cashbook
  [LangKeys.cash]: "నగదు",
  [LangKeys.online]: "ఆన్‌లైన్",
  [LangKeys.total_balance_cashbook]: "మొత్తం మిగిలిన",
  [LangKeys.today_balance]: "ఈరోజు బ్యాలెన్స్",
  [LangKeys.view_report]: "నివేదికను వీక్షించండి",
  [LangKeys.out_entry]: "అవుట్",
  [LangKeys.in_entry]: "ఇన్",
  [LangKeys.add_first_entry]: "మీ మొదటి ఎంట్రీని జోడించండి",
  [LangKeys.attach_bill]: "బిల్‌ను జతచేయండి",
  [LangKeys.enter_amount]: "మొత్తాన్ని నమోదు చేయండి",
  [LangKeys.empty_title]: "ఇంకా ఎంట్రీలు ఏవీ లేవు",
  [LangKeys.saving]: "సేవ్ చేస్తోంది...",
  [LangKeys.save_failed]: "సేవ్ చేయడంలో విఫలమైంది",
  [LangKeys.server_error]: "సర్వర్ లోపం",
  [LangKeys.ok]: "సరే",
  [LangKeys.error]: "లోపం",
  [LangKeys.payment_mode]: "చెల్లింపు విధానం",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "ఎంట్రీ ఆఫ్‌లైన్‌లో సేవ్ అయింది. ఇంటర్నెట్ వచ్చిన వెంటనే సింక్ అవుతుంది",
  [LangKeys.entry_waiting_to_be_synced]: "ఎంట్రీ ఆఫ్‌లైన్‌లో సేవ్ అయింది, సింక్ పెండింగ్‌లో ఉంది",
  [LangKeys.cash_in]: "జమ అయింది",
  [LangKeys.cash_out]: "తీసుకున్నారు",
  [LangKeys.cashbook_status]: "క్యాష్‌బుక్ స్థితి",
  [LangKeys.real_time_cash_online]: "రియల్ టైమ్ నగదు & ఆన్‌లైన్",

  // NEW Cashbook Specific keys
  [LangKeys.entry_is_backed_up]: "ఎంట్రీ బ్యాకప్ చేయబడింది",
  [LangKeys.safe_and_secure]: "100% సురక్షితం మరియు భద్రమైనది",
  [LangKeys.invalid_image_format_cashbook_popup]: "మద్దతు లేని ఫార్మాట్. దయచేసి JPG, PNG, లేదా WEBPని ఉపయోగించండి.",
  [LangKeys.photo_size_error_cashbook_popup]: "ఫైల్ చాలా పెద్దది (గరిష్టంగా 4MB)",
  [LangKeys.selected_image]: "ఎంచుకోబడింది",

  // Cashbook Report Screen keys
  [LangKeys.cashbook_report_title]: "క్యాష్‌బుక్ నివేదిక",
  [LangKeys.date_range]: "తేదీ పరిధి",
  [LangKeys.single_day]: "ఒక రోజు",
  [LangKeys.this_week]: "ఈ వారం",
  [LangKeys.this_month]: "ఈ నెల",
  [LangKeys.last_week]: "గత వారం",
  [LangKeys.last_month]: "గత నెల",
  [LangKeys.all]: "అన్నీ",
  [LangKeys.to]: "కు",
  [LangKeys.no_entries_found_period]: "ఈ వ్యవధిలో ఎంట్రీలు ఏవీ కనుగొనబడలేదు.",
  [LangKeys.daily_balance_short]: "రోజువారీ బ్యాలెన్స్",
  [LangKeys.download_pdf]: "PDFని డౌన్‌లోడ్ చేయండి",
  [LangKeys.pdf_download_not_implemented]: "PDF డౌన్‌లోడ్ ఇంకా అమలు కాలేదు.",

  // Cashbook Report Day Screen keys
  [LangKeys.daily_details]: "రోజువారీ వివరాలు",
  [LangKeys.no_entries_on_this_day]: "ఈ రోజున ఎంట్రీలు ఏవీ లేవు",
  [LangKeys.add_entries_help]: "వాటిని ఇక్కడ చూడటానికి ఎంట్రీలను జోడించండి.",
  [LangKeys.add_entry_to]: "ఎంట్రీని జోడించండి",
  [LangKeys.add_entry]: "ఎంట్రీని జోడించండి",
  [LangKeys.could_not_load_report]: "నివేదికను లోడ్ చేయలేకపోయింది.",

  // NEW Entry Details Screen specific keys
  [LangKeys.delete_failed]: "తొలగించడంలో విఫలమైంది",
  [LangKeys.photo_max_4mb]: "ఫోటో (గరిష్టంగా 4MB)",
  [LangKeys.entry_of_amount]: "మొత్తం యొక్క ఎంట్రీ ",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "రోజువారీ సారాంశం",
  [LangKeys.total_in]: "మొత్తం ఇన్",
  [LangKeys.total_out]: "మొత్తం అవుట్",
  [LangKeys.no_data_available]: "డేటా ఏదీ అందుబాటులో లేదు",

  // Months (for date formatting)
  [LangKeys.month_1]: "జన",
  [LangKeys.month_2]: "ఫిబ్ర",
  [LangKeys.month_3]: "మార్చి",
  [LangKeys.month_4]: "ఏప్రిల్",
  [LangKeys.month_5]: "మే",
  [LangKeys.month_6]: "జూన్",
  [LangKeys.month_7]: "జూలై",
  [LangKeys.month_8]: "ఆగ",
  [LangKeys.month_9]: "సెప్టెం",
  [LangKeys.month_10]: "అక్టో",
  [LangKeys.month_11]: "నవం",
  [LangKeys.month_12]: "డిసెం",

  // NEW Customer Supplier Add
  [LangKeys.add_customer]: "వినియోగదారుని జోడించండి",
  [LangKeys.customer_already_exists]: "గ్రాహకుడు ఇప్పటికే ఉన్నాడు",
  [LangKeys.supplier_already_exists]: "సరఫరాదారు ఇప్పటికే ఉన్నాడు",

  // ✅ NEW CASHBOOK EMPTY STATE
  [LangKeys.cashbook_welcome]: "హలో! ఈరోజు ఎంట్రీలు చేద్దాం",
  [LangKeys.add_first_entry_btn]: "మీ మొదటి ఎంట్రీని జోడించండి",

  // ✅ NEW KEY FOR EMPTY STATE TEXT
  [LangKeys.add_customers_collect_faster]: "కస్టమర్‌లను జోడించండి & చెల్లింపులను వేగంగా సేకరించండి",

  // ✅ NEW KEYS FOR PERMISSIONS
  [LangKeys.permission_denied_title]: "అనుమతి నిరాకరించబడింది",
  [LangKeys.permission_denied_content]: "ఫోటో యాక్సెస్ శాశ్వతంగా నిరాకరించబడింది. దయచేసి యాప్ సెట్టింగ్స్‌కి వెళ్లి దాన్ని ప్రారంభించండి.",
  [LangKeys.permission_denied_settings_button]: "సెట్టింగ్స్ తెరవండి",
  [LangKeys.permission_denied_cancel_button]: "రద్దు చేయండి",
  [LangKeys.permission_denied_generic_message]: "అనుమతి నిరాకరించబడింది. ఫోటోను ఎంచుకోవడానికి దయచేసి ఫోటో యాక్సెస్‌ను అనుమతించండి.",

  // ✅ Contact Picker
  [LangKeys.permission_required]: "అనుమతి అవసరం",
  [LangKeys.contacts_permission_message]: "Contact ఎంచుకోవడానికి Contacts అనుమతి అవసరం. దయచేసి app settings లో అనుమతిని enable చేయండి.",
  [LangKeys.failed_to_open_contacts_picker]: "Contacts picker తెరవడం విఫలమైంది.",
  [LangKeys.permission_denied_to_read_contacts]: "Contacts చదవడానికి అనుమతి నిరాకరించబడింది.",

  // ================= ADD ITEM SCREEN =================
  [LangKeys.tax_exempted]: "పన్ను మినహాయింపు",
  [LangKeys.no_gst]: "GST లేదు",
  [LangKeys.select_photo]: "ఫోటో ఎంచుకోండి",
  [LangKeys.gallery]: "గ్యాలరీ",
  [LangKeys.camera]: "కెమెరా",
  [LangKeys.please_enter_item_name]: "దయచేసి ఐటమ్ పేరు నమోదు చేయండి",
  [LangKeys.failed_to_upload_image]: "చిత్రాన్ని అప్‌లోడ్ చేయలేకపోయాము",
  [LangKeys.item_updated_successfully]: "ఐటమ్ విజయవంతంగా నవీకరించబడింది",
  [LangKeys.item_saved_successfully]: "ఐటమ్ విజయవంతంగా సేవ్ చేయబడింది",
  [LangKeys.failed_to_update_item]: "ఐటమ్ నవీకరణ విఫలమైంది",
  [LangKeys.failed_to_save_item]: "ఐటమ్ సేవ్ చేయడం విఫలమైంది",
  [LangKeys.confirm_deletion]: "డిలీట్ నిర్ధారణ",
  [LangKeys.are_you_sure_delete_item]: "ఈ ఐటమ్‌ను డిలీట్ చేయాలనుకుంటున్నారా?",
  [LangKeys.item_deleted_successfully]: "ఐటమ్ విజయవంతంగా డిలీట్ చేయబడింది",
  [LangKeys.failed_to_delete_item]: "ఐటమ్ డిలీట్ చేయడం విఫలమైంది",
  [LangKeys.edit_item]: "ఐటమ్ ఎడిట్ చేయండి",
  [LangKeys.edit_service]: "సేవ ఎడిట్ చేయండి",
  [LangKeys.add_product]: "ప్రోడక్ట్ జోడించండి",
  [LangKeys.add_service]: "సేవ జోడించండి",
  [LangKeys.add_hsn_and_gst_details]: "HSN మరియు GST వివరాలు జోడించండి",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "HSN నమోదు చేయండి",
  [LangKeys.gst_rate_percent]: "GST రేటు (%)",
  [LangKeys.enter_gst_rate]: "GST రేటు నమోదు చేయండి",
  [LangKeys.primary_unit]: "ప్రధాన యూనిట్",
  [LangKeys.enter_item_name_here]: "ఇక్కడ ఐటమ్ పేరు వ్రాయండి",
  [LangKeys.sale_price]: "అమ్మకపు ధర",
  [LangKeys.purchase_price]: "కొనుగోలు ధర",
  [LangKeys.tax_included]: "ధరలో పన్ను చేర్చబడింది",
  [LangKeys.opening_stock]: "ప్రారంభ స్టాక్",
  [LangKeys.low_stock_alert]: "తక్కువ స్టాక్ హెచ్చరిక",
  [LangKeys.as_of_date]: "తేదీ వరకు",
  [LangKeys.enter_price]: "ధర నమోదు చేయండి",
  [LangKeys.enter_count]: "పరిమాణం నమోదు చేయండి",
  [LangKeys.save_item]: "ఐటమ్ సేవ్ చేయండి",
  [LangKeys.delete_item]: "ఐటమ్ డిలీట్ చేయండి",
  [LangKeys.select_unit]: "యూనిట్ ఎంచుకోండి",
  [LangKeys.search_unit]: "యూనిట్ వెతకండి",
  [LangKeys.add_gst_rate]: "GST రేటు జోడించండి",
  [LangKeys.add_custom_tax]: "కస్టమ్ పన్ను జోడించండి",
  [LangKeys.custom_tax]: "కస్టమ్ పన్ను",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "సెస్",
  [LangKeys.add_hsn_code]: "HSN కోడ్ జోడించండి",
  [LangKeys.hsn_code]: "HSN కోడ్",
  [LangKeys.item_name]: "ఐటమ్ పేరు",
  [LangKeys.enter_hsn_code]: "HSN కోడ్ నమోదు చేయండి",
  [LangKeys.enter_item_name]: "ఐటమ్ పేరు నమోదు చేయండి",
  [LangKeys.results]: "ఫలితాలు",
  [LangKeys.no_hsn_code_found]: "HSN కోడ్ లభించలేదు",
  [LangKeys.use]: "వాడండి",
  [LangKeys.as_hsn_code]: "HSN కోడ్‌గా",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "మీరు ఆఫ్‌లైన్‌లో ఉన్నారు. దయచేసి ఇంటర్నెట్‌కు కనెక్ట్ అవ్వండి.",

  // ================= ITEMS SCREEN =================
  [LangKeys.products]: "ప్రోడక్ట్స్",
  [LangKeys.services]: "సేవలు",
  [LangKeys.add_product_caps]: "ప్రోడక్ట్ జోడించండి",
  [LangKeys.add_service_caps]: "సేవ జోడించండి",
  [LangKeys.add_items_and_get_started]: "మీ ఇన్వెంటరీని నిర్వహించడం ప్రారంభించండి",
  [LangKeys.manage_stock_feature]: "మీ వ్యాపారానికి స్మార్ట్ స్టాక్ నియంత్రణ",
  [LangKeys.detailed_stock_history_feature]: "అంశాల కార్యకలాపాల పూర్తి రికార్డులను యాక్సెస్ చేయండి",
  [LangKeys.track_prices_and_profits_feature]: "ధరలు మరియు లాభ మార్జిన్లను సులభంగా పర్యవేక్షించండి",
  [LangKeys.search_items]: "ఐటమ్‌లను వెతకండి",
  [LangKeys.my_items]: "నా ఐటమ్‌లు",
  [LangKeys.item_added]: "ఐటమ్ జోడించబడింది",
  [LangKeys.low_stock]: "తక్కువ స్టాక్",
  [LangKeys.current_stock]: "ప్రస్తుత స్టాక్",
  [LangKeys.stock_history]: "స్టాక్ చరిత్ర",
  [LangKeys.stock_in]: "స్టాక్ ఇన్",
  [LangKeys.stock_out]: "స్టాక్ అవుట్",
  [LangKeys.add_services_and_get_started]: "మీ సేవలను నిర్వహించడం ప్రారంభించండి",
  [LangKeys.manage_services_feature]: "మీ అన్ని సేవా ఆఫరింగ్స్‌ను క్రమబద్ధీకరించి నిర్వహించండి",
  [LangKeys.save_sac_and_gst_feature]: "SAC కోడ్లు మరియు GST వివరాలను సులభంగా సేవ్ చేయండి",
  [LangKeys.track_sales_and_bills_feature]: "సేవా అమ్మకాలు మరియు బిల్లింగ్ రికార్డులను ట్రాక్ చేయండి",
  [LangKeys.net_monthly_sales]: "మొత్తం నెలవారీ అమ్మకాలు",
  [LangKeys.rupees]: "రూపాయలు",
  [LangKeys.search_services]: "సేవలను వెతకండి",
  [LangKeys.my_services]: "నా సేవలు",
  [LangKeys.service_price]: "సేవ ధర",
  [LangKeys.unit]: "యూనిట్",
  [LangKeys.enter_purchased_quantity]: "కొనుగోలు చేసిన పరిమాణం నమోదు చేయండి",
  [LangKeys.enter_sold_quantity]: "అమ్మిన పరిమాణం నమోదు చేయండి",
  [LangKeys.quantity]: "పరిమాణం",
  [LangKeys.add_notes_optional]: "గమనికలు జోడించండి (ఐచ్చికం)",
  [LangKeys.stock_in_caps]: "స్టాక్ ఇన్",
  [LangKeys.stock_out_caps]: "స్టాక్ అవుట్",
  [LangKeys.total_stock]: "మొత్తం స్టాక్",
  [LangKeys.low_stock_items]: "తక్కువ స్టాక్ ఉన్న వస్తువులు",
  [LangKeys.all_items]: "అన్ని వస్తువులు",
  [LangKeys.failed_to_load_items]: "అంశాలను లోడ్ చేయడంలో విఫలమైంది",


  [LangKeys.item_sales_report]: "వస్తు అమ్మకాల నివేదిక",
  [LangKeys.total_qty_sold]: "మొత్తం అమ్మిన పరిమాణం",
  [LangKeys.units]: "యూనిట్లు",
  [LangKeys.nos]: "సంఖ్య",
  [LangKeys.sold]: "అమ్మినవి",
  [LangKeys.bought]: "కొన్నవి",
  [LangKeys.profit]: "లాభం",
  [LangKeys.loss]: "నష్టం",

  // Filter & Sort
  [LangKeys.filter_by_stock]: "స్టాక్ ఆధారంగా ఫిల్టర్ చేయండి",
  [LangKeys.sort_by_name_az]: "పేరు (A–Z) క్రమంలో",
  [LangKeys.sort_by_name_za]: "పేరు (Z–A) క్రమంలో",

  // ================= ADD SERVICE SCREEN =================
  [LangKeys.failed_to_process_image]: "చిత్రాన్ని ప్రాసెస్ చేయలేకపోయాము",
  [LangKeys.could_not_pick_image]: "చిత్రాన్ని ఎంచుకోలేకపోయాము",
  [LangKeys.failed_to_upload_photo]: "ఫోటో అప్‌లోడ్ చేయలేకపోయాము",
  [LangKeys.failed_to_update_service]: "సేవను నవీకరించలేకపోయాము",
  [LangKeys.failed_to_add_service]: "సేవను జోడించలేకపోయాము",
  [LangKeys.are_you_sure_delete_service]: "ఈ సేవను డిలీట్ చేయాలనుకుంటున్నారా?",
  [LangKeys.failed_to_delete_service]: "సేవను డిలీట్ చేయలేకపోయాము",
  [LangKeys.add_sac_and_gst_details]: "SAC మరియు GST వివరాలు జోడించండి",
  [LangKeys.sac_code]: "SAC కోడ్",
  [LangKeys.enter_sac]: "SAC నమోదు చేయండి",
  [LangKeys.enter_service_name_here]: "ఇక్కడ సేవ పేరు వ్రాయండి",
  [LangKeys.please_enter_service_name]: "దయచేసి సేవ పేరు నమోదు చేయండి",
  [LangKeys.tax_included_in_price]: "ధరలో పన్ను చేర్చబడింది",
  [LangKeys.delete_service]: "సేవ డిలీట్ చేయండి",
  [LangKeys.save_changes]: "మార్పులను సేవ్ చేయండి",

  // ================= ITEM DETAILS SCREEN =================
  [LangKeys.edit_product]: "ప్రోడక్ట్ ఎడిట్ చేయండి",
  [LangKeys.stock_quantity]: "స్టాక్ పరిమాణం",
  [LangKeys.stock_value]: "స్టాక్ విలువ",

  // ================= SERVICE DETAILS SCREEN =================
  [LangKeys.edit_service_caps]: "సేవ ఎడిట్ చేయండి",
  [LangKeys.service_name]: "సేవ పేరు",
  [LangKeys.gst_percent]: "GST %",
  [LangKeys.no_sales_added_for_service]: "ఈ సేవకు ఎలాంటి అమ్మకాలు జోడించలేదు",
  [LangKeys.zero_percent]: "0%",

  /* ================= BILLS SCREEN ================= */
  [LangKeys.bills_add_sale]: "విక్రయం జోడించండి",
  [LangKeys.bills_search_sales_hint]: "విక్రయాలను వెతకండి",
  [LangKeys.bills_add_purchase]: "కొనుగోలు జోడించండి",
  [LangKeys.bills_search_purchases_hint]: "కొనుగోళ్లను వెతకండి",
  [LangKeys.bills_add_expense]: "ఖర్చు జోడించండి",
  [LangKeys.bills_search_expenses_hint]: "ఖర్చులను వెతకండి",
  [LangKeys.bills_start_creating_gst]: "GST బిల్లులు తయారు చేయడం ప్రారంభించండి",
  [LangKeys.bills_tab_sale]: "విక్రయం",
  [LangKeys.bills_tab_purchase]: "కొనుగోలు",
  [LangKeys.bills_tab_expense]: "ఖర్చు",
  [LangKeys.bills_monthly_sales]: "నెలవారీ విక్రయాలు",
  [LangKeys.bills_monthly_purchases]: "నెలవారీ కొనుగోళ్లు",
  [LangKeys.bills_view_reports]: "రిపోర్టులు చూడండి",
  [LangKeys.bills_todays_in]: "ఈరోజు వచ్చిన మొత్తం",
  [LangKeys.bills_todays_out]: "ఈరోజు ఖర్చు",
  [LangKeys.bills_cashbook]: "క్యాష్‌బుక్",
  [LangKeys.bills_empty_state_title]: "క్షణాల్లో ప్రొఫెషనల్ ఇన్వాయిస్‌లను తయారు చేయండి",
  [LangKeys.bills_empty_state_subtitle]: "లెడ్జర్, స్టాక్ & క్యాష్‌బుక్ ఆటోమేటిక్‌గా అప్‌డేట్ అవుతాయి",
  [LangKeys.bills_empty_state_gst_support]: "GST మరియు Non-GST బిల్లింగ్ మద్దతు",
  [LangKeys.bills_see_sample_invoices]: "నమూనా ఇన్వాయిస్‌లను చూడండి",
  [LangKeys.bills_no_matching_found]: "సరిపోయే బిల్లులు లభించలేదు",
  [LangKeys.bills_payment_in]: "ప్రాప్తి చెల్లింపు",
  [LangKeys.bills_status_fully_paid]: "పూర్తిగా చెల్లించబడింది",
  [LangKeys.bills_status_unpaid]: "చెల్లించాలి",
  [LangKeys.bills_sale_bill]: "విక్రయ బిల్",
  [LangKeys.bills_purchase_bill]: "కొనుగోలు బిల్",
  [LangKeys.bills_expense_bill]: "ఖర్చు",
  [LangKeys.bills_more_button]: "మరిన్ని",
  [LangKeys.bills_added_to_ledger]: "✓ లెడ్జర్‌లో జోడించబడింది",

  // ================= FILTER & SORT =================
  [LangKeys.filter_and_sort]: "ఫిల్టర్ & సార్ట్",
  [LangKeys.filter_by_status]: "స్థితి ప్రకారం ఫిల్టర్ చేయండి",
  [LangKeys.filter_all_bills]: "అన్ని బిల్లులు",
  [LangKeys.filter_paid_bills]: "చెల్లించిన బిల్లులు",
  [LangKeys.filter_unpaid_bills]: "చెల్లించని బిల్లులు",
  [LangKeys.sort_by]: "క్రమబద్ధీకరించు",
  [LangKeys.sort_latest_first]: "కొత్తవి ముందుగా",
  [LangKeys.sort_oldest_first]: "పాతవి ముందుగా",
  [LangKeys.sort_highest_amount]: "అత్యధిక మొత్తం",
  [LangKeys.sort_lowest_amount]: "అత్యల్ప మొత్తం",
  [LangKeys.clear_filters]: "ఫిల్టర్ తొలగించు",
  [LangKeys.apply_filters]: "ఫిల్టర్ అమలు చేయు",
  [LangKeys.item_stock_sales_report_desc]: "ఉత్పత్తులు మరియు సేవల కోసం స్టాక్ మరియు సేల్స్ సారాంశం",
  [LangKeys.select_party]: "పార్టీని ఎంచుకోండి",
  [LangKeys.search_placeholder]: "పేరు లేదా మొబైల్ ద్వారా వెతకండి...",
  [LangKeys.back_to_dashboard]: "రిపోర్ట్స్ మెనూకు తిరిగి వెళ్ళండి",
  [LangKeys.loading_report_data]: "రిపోర్ట్ డేటా లోడ్ అవుతోంది...",
  [LangKeys.no_parties_found]: "ఎలాంటి పార్టీలు లభించలేదు.",
  [LangKeys.select_customer]: "రిపోర్ట్ చూడటానికి కస్టమర్‌ని ఎంచుకోండి",
  [LangKeys.select_supplier]: "రిపోర్ట్ చూడటానికి సప్లయర్‌ని ఎంచుకోండి",
  [LangKeys.premium_feature]: "ప్రీమియం ఫీచర్",
  [LangKeys.premium_lock_desc]: "ప్రొఫెషనల్ బిల్లింగ్, సేల్స్/పర్చేజ్ ఇన్వాయిస్ రిపోర్ట్‌లు, డేబుక్ స్టేట్‌మెంట్‌లు మరియు ఇన్వెంటరీ సారాంశాలను అన్‌లాక్ చేయండి.",
  [LangKeys.upgrade_to_premium]: "యాడ్స్ ఫ్రీ+ / ప్రీమియమ్‌కు అప్‌గ్రేడ్ చేయండి 🚀",

  /* ================= ADD BILL SCREEN ================= */
  [LangKeys.add_bill_sale]: "విక్రయం",
  [LangKeys.add_bill_purchase]: "కొనుగోలు",
  [LangKeys.add_bill_expense]: "ఖర్చు",
  [LangKeys.add_bill_edit_sale_gst_bill]: "విక్రయ GST బిల్ సవరించండి",
  [LangKeys.add_bill_sale_gst_bill]: "విక్రయ GST బిల్",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "కొనుగోలు GST బిల్ సవరించండి",
  [LangKeys.add_bill_purchase_gst_bill]: "కొనుగోలు GST బిల్",
  [LangKeys.add_bill_edit_expense]: "ఖర్చు సవరించండి",
  [LangKeys.add_bill_expense_title]: "ఖర్చు",
  [LangKeys.add_bill_edit_sale_bill]: "విక్రయ బిల్ సవరించండి",
  [LangKeys.add_bill_sale_bill]: "విక్రయ బిల్",
  [LangKeys.add_bill_edit_purchase_bill]: "కొనుగోలు బిల్ సవరించండి",
  [LangKeys.add_bill_purchase_bill]: "కొనుగోలు బిల్",
  [LangKeys.add_bill_sale_bill_no]: "విక్రయ బిల్ నం.",
  [LangKeys.add_bill_purchase_bill_no]: "కొనుగోలు బిల్ నం.",
  [LangKeys.add_bill_expense_no]: "ఖర్చు నం.",
  [LangKeys.add_bill_update_sale_bill]: "విక్రయ బిల్ అప్‌డేట్ చేయండి",
  [LangKeys.add_bill_generate_sale_bill]: "విక్రయ బిల్ రూపొందించండి",
  [LangKeys.add_bill_update_purchase_bill]: "కొనుగోలు బిల్ అప్‌డేట్ చేయండి",
  [LangKeys.add_bill_generate_purchase_bill]: "కొనుగోలు బిల్ రూపొందించండి",
  [LangKeys.add_bill_update_expense]: "ఖర్చు అప్‌డేట్ చేయండి",
  [LangKeys.add_bill_generate_expense]: "ఖర్చు జోడించండి",
  [LangKeys.add_bill_select_customer_error]: "దయచేసి కస్టమర్‌ను ఎంచుకోండి",
  [LangKeys.add_bill_add_item_error]: "కనీసం ఒక వస్తువును జోడించండి",
  [LangKeys.add_bill_updated_successfully]: "విజయవంతంగా అప్‌డేట్ అయింది",
  [LangKeys.add_bill_saved_successfully]: "విజయవంతంగా సేవ్ చేయబడింది",
  [LangKeys.add_bill_failed_to_save]: "బిల్ సేవ్ చేయడంలో విఫలమైంది",
  [LangKeys.add_bill_error_occurred]: "ఏదో తప్పు జరిగింది",
  [LangKeys.add_bill_bill_to]: "బిల్ ఎవరి పేరుకు",
  [LangKeys.add_bill_search_parties]: "పార్టీలను వెతకండి",
  [LangKeys.add_bill_add_new_party]: "కొత్త పార్టీ జోడించండి",
  [LangKeys.add_bill_edit_party_details]: "పార్టీ వివరాలు సవరించండి",
  [LangKeys.add_bill_items]: "వస్తువులు",
  [LangKeys.add_bill_enter_items_from_inventory]: "స్టాక్ నుండి వస్తువులు నమోదు చేయండి",
  [LangKeys.add_bill_add_new_item]: "కొత్త వస్తువు జోడించండి",
  [LangKeys.add_bill_n_items]: "{n} వస్తువులు",
  [LangKeys.add_bill_edit_or_add_items]: "వస్తువులను సవరించండి లేదా జోడించండి",
  [LangKeys.add_bill_discount]: "తగ్గింపు",
  [LangKeys.add_bill_extra_discount]: "అదనపు డిస్కౌంట్",
  [LangKeys.add_bill_item_subtotal]: "వస్తువు ఉప మొత్తం",
  [LangKeys.add_bill_round_off]: "రౌండ్ ఆఫ్",
  [LangKeys.add_bill_bill_amount]: "బిల్ మొత్తం",
  [LangKeys.add_bill_optional_fields]: "ఐచ్ఛిక ఫీల్డ్స్",
  [LangKeys.add_bill_printed_on_invoice]: "ఇన్వాయిస్‌పై ముద్రించబడుతుంది",
  [LangKeys.add_bill_custom_fields]: "కస్టమ్ ఫీల్డ్స్",
  [LangKeys.add_bill_party_address]: "పార్టీ చిరునామా",
  [LangKeys.add_bill_your_address]: "మీ చిరునామా",
  [LangKeys.add_bill_terms_conditions]: "నిబంధనలు & షరతులు",
  [LangKeys.add_bill_private_to_you]: "మీకు మాత్రమే",
  [LangKeys.add_bill_add_notes_photos]: "గమనికలు లేదా ఫోటోలు జోడించండి",
  [LangKeys.add_bill_n_photos_added]: "{n} ఫోటోలు జోడించబడ్డాయి",
  [LangKeys.add_bill_balance_due]: "బాకీ మొత్తం",
  [LangKeys.cgst]: "CGST",
  [LangKeys.sgst]: "SGST",
  [LangKeys.pending_bill_no]: "బాకీ బిల్ నం.",
  [LangKeys.add_bill_add_due_to_ledger]: "లెడ్జర్‌లో బకాయి బ్యాలెన్స్ జోడించండి",
  [LangKeys.add_bill_select_supplier_error]: "దయచేసి సరఫరాదారుని ఎంపిక చేయండి",

  /* ================= BILL DETAILS SCREEN ================= */
  [LangKeys.bill_details_error_id_missing]: "బిల్ ID లేదు",
  [LangKeys.bill_details_failed_to_load]: "బిల్ లోడ్ చేయడంలో విఫలమైంది",
  [LangKeys.bill_details_delete_confirmation_title]: "బిల్ తొలగించండి",
  [LangKeys.bill_details_delete_confirmation_content]: "మీరు ఈ బిల్లును తొలగించాలనుకుంటున్నారా? దయచేసి గుర్తుంచుకోండి, ఈ బిల్లుతో సంబంధించిన క్యాష్‌బుక్ ఎంట్రీ కూడా తొలగించబడుతుంది.",
  [LangKeys.bill_details_delete_button]: "తొలగించండి",
  [LangKeys.bill_details_deleted_successfully]: "బిల్ విజయవంతంగా తొలగించబడింది",
  [LangKeys.bill_details_failed_to_delete]: "బిల్ తొలగించడంలో విఫలమైంది",
  [LangKeys.bill_details_generating_pdf]: "PDF తయారవుతోంది",
  [LangKeys.bill_details_share_text]: "ఇది మీ బిల్",
  [LangKeys.bill_details_failed_to_share]: "బిల్ షేర్ చేయడంలో విఫలమైంది",
  [LangKeys.bill_details_title]: "బిల్ వివరాలు",
  [LangKeys.bill_details_could_not_load]: "బిల్ వివరాలు లోడ్ కాలేదు",
  [LangKeys.bill_details_status]: "స్థితి",
  [LangKeys.bill_details_status_pending]: "పెండింగ్",
  [LangKeys.bill_details_no_items]: "ఏ వస్తువులు జోడించలేదు",
  [LangKeys.bill_details_view_pdf]: "PDF చూడండి",

  /* ================= EXPENSE DETAILS SCREEN ================= */
  [LangKeys.expense_number_prefix]: "ఖర్చు #",
  [LangKeys.edit_expense]: "ఖర్చును సవరించండి",
  [LangKeys.delete_expense]: "ఖర్చును తొలగించండి",
  [LangKeys.deleting_expense]: "తొలగిస్తోంది...",
  [LangKeys.expense_deleted_successfully]: "ఖర్చు విజయవంతంగా తొలగించబడింది",
  [LangKeys.failed_to_delete_expense]: "ఖర్చును తొలగించడంలో విఫలమైంది",
  [LangKeys.edit_feature_coming_soon]: "సవరింపు ఫీచర్ త్వరలో వస్తోంది!",
  [LangKeys.delete_expense_confirmation]: "మీరు ఈ ఖర్చును ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?",

  /* ================= INVOICE PREVIEW SCREEN ================= */
  [LangKeys.invoice_preview_title]: "ఇన్వాయిస్ ప్రివ్యూ",
  [LangKeys.invoice_preview_generating]: "ఇన్వాయిస్ తయారవుతోంది",
  [LangKeys.invoice_preview_failed]: "ఇన్వాయిస్ తయారుకాలేదు",
  [LangKeys.invoice_preview_preparing_print]: "ప్రింట్‌కు సిద్ధంగా ఉంది",
  [LangKeys.invoice_preview_failed_print]: "ప్రింట్ చేయలేకపోయాం",
  [LangKeys.invoice_preview_delete_content]: "మీరు ఈ ఇన్వాయిస్‌ను తొలగించాలనుకుంటున్నారా? దయచేసి గమనించండి, దీనికి సంబంధించిన క్యాష్‌బుక్ ఎంట్రీ కూడా తొలగించబడుతుంది.",
  [LangKeys.invoice_preview_delete_title]: "ఇన్వాయిస్ తొలగించండి",
  [LangKeys.invoice_preview_deleted_successfully]: "ఇన్వాయిస్ విజయవంతంగా తొలగింది",
  [LangKeys.invoice_preview_failed_delete]: "ఇన్వాయిస్ తొలగింపు విఫలమైంది",
  [LangKeys.invoice_preview_theme_premium]: "ప్రీమియం",
  [LangKeys.invoice_preview_theme_thermal]: "థర్మల్",
  [LangKeys.invoice_preview_theme_basic]: "బేసిక్",
  [LangKeys.invoice_preview_theme_new]: "కొత్తది",
  [LangKeys.invoice_preview_download]: "ఇన్వాయిస్ డౌన్‌లోడ్",
  [LangKeys.invoice_preview_share]: "ఇన్వాయిస్ షేర్",
  [LangKeys.invoice_preview_print]: "ఇన్వాయిస్ ప్రింట్",
  [LangKeys.invoice_preview_create_new]: "కొత్త ఇన్వాయిస్",
  [LangKeys.invoice_preview_done]: "పూర్తి",

  /* ================= PAYMENT DETAILS SCREEN ================= */
  [LangKeys.payment_details_title_in]: "ప్రాప్తి చెల్లింపు",
  [LangKeys.payment_details_title_out]: "చెల్లించిన మొత్తం",
  [LangKeys.payment_details_share_text]: "చెల్లింపు వివరాలు",
  [LangKeys.payment_details_failed_to_share]: "చెల్లింపు వివరాలు షేర్ చేయడంలో విఫలమైంది",
  [LangKeys.payment_details_adjusted_invoices]: "సర్దుబాటు చేసిన ఇన్వాయిస్‌లు",

  /* ================= SAMPLE INVOICES SCREEN ================= */
  [LangKeys.sample_invoice_title]: "నమూనా",
  [LangKeys.premium_invoice]: "ప్రీమియం ఇన్వాయిస్",
  [LangKeys.thermal_invoice]: "థర్మల్ ఇన్వాయిస్",
  [LangKeys.basic_invoice]: "బేసిక్ ఇన్వాయిస్",
  [LangKeys.use_this_template]: "ఈ టెంప్లేట్ ఉపయోగించండి",

  /* ================= ITEM SELECT SHEET ================= */
  [LangKeys.item_select_not_enough_stock]: "తగినంత స్టాక్ లేదు. కేవలం {availableStock} మాత్రమే అందుబాటులో ఉంది.",
  [LangKeys.item_select_no_items_found]: "ఏ వస్తువులు కనబడలేదు",
  [LangKeys.item_select_item_discount]: "వస్తువు తగ్గింపు",
  [LangKeys.item_select_final_price]: "చివరి ధర",
  [LangKeys.item_select_gst_rate]: "GST రేటు",
  [LangKeys.item_select_item_single]: "వస్తువు",
  [LangKeys.item_select_item_plural]: "వస్తువులు",
  [LangKeys.item_select_continue]: "కొనసాగించండి",
  [LangKeys.item_select_add_items_to_invoice]: "ఇన్వాయిస్‌కు వస్తువులు జోడించండి",
  [LangKeys.item_select_search_created_items]: "సృష్టించిన వస్తువులను వెతకండి",
  [LangKeys.item_select_add_new]: "కొత్తది జోడించండి",

  /* ================= QUICK ADD ITEM DIALOG ================= */
  [LangKeys.add_more_details]: "మరిన్ని వివరాలు జోడించండి (స్టాక్, కొనుగోలు ధర మొదలైనవి)",
  [LangKeys.add_item_to_bill]: "బిల్లులో వస్తువును జోడించండి",
  [LangKeys.please_enter_value]: "దయచేసి ఒక విలువను నమోదు చేయండి",
  [LangKeys.please_enter_valid_number]: "దయచేసి సరైన సంఖ్యను నమోదు చేయండి",

  /* ================= CUSTOM FIELDS DIALOG ================= */
  [LangKeys.add_bill_custom_fields_subtitle]: "గరిష్టంగా 5 కస్టమ్ ఫీల్డ్స్ జోడించండి (ఉదా: సీరియల్ నంబర్, బ్యాచ్, IMEI మొదలైనవి)",
  [LangKeys.add_bill_add_new_custom_field]: "కొత్త కస్టమ్ ఫీల్డ్ జోడించండి",
  [LangKeys.add_bill_max_custom_fields]: "మీరు గరిష్టంగా 5 కస్టమ్ ఫీల్డ్స్ మాత్రమే జోడించగలరు.",
  [LangKeys.add_bill_custom_field_name_hint]: "ఫీల్డ్ పేరు",
  [LangKeys.add_bill_custom_field_value_hint]: "విలువ",

  /* ================= EDIT PRICE DIALOG ================= */
  [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "తగ్గింపును నమోదు చేయండి",
  [LangKeys.rupee]: "రూపాయి",
  [LangKeys.percentage]: "శాతం",
  [LangKeys.rate]: "రేటు",
  [LangKeys.tax]: "పన్ను",

  /* ================= ADDRESS SCREEN ================= */
  [LangKeys.address_business_address_title]: "వ్యాపార చిరునామా",
  [LangKeys.address_flat_building_number]: "ఫ్లాట్ / భవనం నంబర్",
  [LangKeys.address_enter_flat_building_number]: "దయచేసి ఫ్లాట్ / భవనం నంబర్ నమోదు చేయండి",
  [LangKeys.address_area_locality]: "ప్రాంతం / కాలనీ",
  [LangKeys.address_enter_area_locality]: "దయచేసి ప్రాంతం / కాలనీ నమోదు చేయండి",
  [LangKeys.address_city]: "నగరం",
  [LangKeys.address_enter_city]: "దయచేసి నగరాన్ని నమోదు చేయండి",
  [LangKeys.address_state]: "రాష్ట్రం",
  [LangKeys.address_enter_state]: "దయచేసి రాష్ట్రాన్ని నమోదు చేయండి",
  [LangKeys.address_pincode]: "పిన్‌కోడ్",
  [LangKeys.address_enter_pincode]: "దయచేసి పిన్‌కోడ్ నమోదు చేయండి",
  [LangKeys.address_invalid_pincode]: "చెల్లని పిన్‌కోడ్",

  /* ================= PARTY ADDRESS SCREEN ================= */
  [LangKeys.party_address_title]: "కస్టమర్ చిరునామా",
  [LangKeys.party_address_billing_address]: "బిల్లింగ్ చిరునామా",
  [LangKeys.party_address_shipping_same_as_billing]: "షిప్పింగ్ చిరునామా బిల్లింగ్ చిరునామాతో సమానం",

  /* ================= ADD NOTES AND PHOTOS DIALOG ================= */
  [LangKeys.add_notes_and_photos_title]: "గమనికలు & ఫోటోలు జోడించండి",
  [LangKeys.add_notes_and_photos_subtitle]: "అదనపు వివరాలు లేదా చిత్రాలను జోడించండి",
  [LangKeys.add_notes_and_photos_notes_hint]: "ఇక్కడ గమనికలు రాయండి",
  [LangKeys.photos_access_permanently_denied]: "ఫోటో యాక్సెస్ శాశ్వతంగా నిరాకరించబడింది. దయచేసి యాప్ సెట్టింగ్స్‌లోకి వెళ్లి అనుమతిని ప్రారంభించండి.",
  [LangKeys.photos_access_denied]: "ఫోటోను ఎంచుకోవడానికి, మీ పరికరం సెట్టింగ్స్‌లో కెమెరా లేదా ఫోటో యాక్సెస్‌కు అనుమతి ఇవ్వండి.",
  [LangKeys.open_settings]: "సెట్టింగ్స్ తెరవండి",

  /* ================= TERMS AND CONDITIONS DIALOG ================= */
  [LangKeys.terms_and_conditions_title]: "నిబంధనలు & షరతులు",
  [LangKeys.terms_and_conditions_hint]: "నిబంధనలు మరియు షరతులను నమోదు చేయండి",

  // ================= KHATA TABS =================
  [LangKeys.customers]: "గ్రాహకులు",
  [LangKeys.suppliers]: "సరఫరాదారులు",
  [LangKeys.search_supplier]: "సరఫరాదారుని వెతకండి",
  [LangKeys.add_first_customer]: "మీ మొదటి గ్రాహకుడిని జోడించండి",
  [LangKeys.add_first_supplier]: "మీ మొదటి సరఫరాదారుని జోడించండి",
  [LangKeys.add_new_customer_prompt]: "ఇప్పటివరకు ఏ గ్రాహకుడూ జోడించబడలేదు. కొత్త గ్రాహకుడిని జోడించడానికి పై ఉన్న “+” బటన్‌పై ట్యాప్ చేయండి.",
  [LangKeys.add_new_suppliers_prompt]: "ఇప్పటివరకు ఏ సరఫరాదారుడూ జోడించబడలేదు. కొత్త సరఫరాదారుడిని జోడించడానికి పై ఉన్న “+” బటన్‌పై ట్యాప్ చేయండి.",

  // ================= CASHBOOK HELP DIALOG =================
  [LangKeys.cashbook_help_title]: "క్యాష్‌బుక్ సహాయం",
  [LangKeys.cashbook_help_in_title]: "క్యాష్ ఇన్ (జమా)",
  [LangKeys.cashbook_help_in_desc]: "ఇక్కడ మీ వ్యాపారంలో పొందిన అన్ని నగదు నమోదు వివరాలు చూపబడతాయి.",
  [LangKeys.cashbook_help_out_title]: "క్యాష్ అవుట్ (ఖర్చు)",
  [LangKeys.cashbook_help_out_desc]: "ఇక్కడ మీ వ్యాపారంలో ఖర్చు చేసిన అన్ని నగదు నమోదు వివరాలు చూపబడతాయి.",
  [LangKeys.cashbook_help_total_balance_title]: "మొత్తం నిల్వ",
  [LangKeys.cashbook_help_total_balance_desc]: "ఇది మీ క్యాష్‌బుక్ యొక్క ప్రస్తుత మొత్తం నిల్వను చూపిస్తుంది.",
  [LangKeys.cashbook_help_today_balance_title]: "ఈరోజు నిల్వ",
  [LangKeys.cashbook_help_today_balance_desc]: "ఇది ఈరోజు జరిగిన నగదు లావాదేవీల ఆధారంగా నిల్వను చూపిస్తుంది.",
  [LangKeys.cashbook_help_report_title]: "క్యాష్‌బుక్ నివేదిక",
  [LangKeys.cashbook_help_report_desc]: "ఇక్కడ నుండి మీరు క్యాష్‌బుక్ నివేదికను చూడవచ్చు మరియు డౌన్‌లోడ్ చేసుకోవచ్చు.",

  // ✅ NEW KEYS FOR ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "ఖర్చు మొత్తం",
  [LangKeys.select_category]: "వర్గాన్ని ఎంచుకోండి",
  [LangKeys.select_expense_category]: "ఖర్చు వర్గాన్ని ఎంచుకోండి",
  [LangKeys.expense_items_warning]: "ఖర్చు అంశాలు మీ ఇన్వెంటరీ అంశాలను ప్రభావితం చేయవు.",
  [LangKeys.add_expense_items_optional]: "ఖర్చు అంశాలను జోడించండి (ఐచ్చికం)",
  [LangKeys.expense_items_feature_coming_soon]: "ఖర్చు అంశాల ఫీచర్ త్వరలో వస్తోంది!",
  [LangKeys.notes_and_photos_optional]: "గమనికలు మరియు ఫోటోలు (ఐచ్చికం)",
  [LangKeys.photos_added]: "ఫోటోలు జోడించబడ్డాయి",
  [LangKeys.save_expense_amount]: "ఖర్చును సేవ్ చేయండి",
  [LangKeys.update_expense_amount]: "ఖర్చును అప్డేట్ చేయండి",
  [LangKeys.expense_saved_successfully]: "ఖర్చు విజయవంతంగా సేవ్ చేయబడింది",
  [LangKeys.expense_updated_successfully]: "ఖర్చు విజయవంతంగా అప్డేట్ చేయబడింది",
  [LangKeys.failed_to_save_expense]: "ఖర్చును సేవ్ చేయడంలో విఫలమైంది",
  [LangKeys.enter_valid_amount]: "దయచేసి సరైన మొత్తాన్ని నమోదు చేయండి.",
  [LangKeys.please_select_expense_category]: "దయచేసి ఖర్చు వర్గాన్ని ఎంచుకోండి.",
  [LangKeys.category]: "వర్గం",

  // ===== EXPENSE CATEGORIES =====
  [LangKeys.cat_rent]: "అద్దె",
  [LangKeys.cat_salaries]: "జీతాలు / కూలి",
  [LangKeys.cat_electricity]: "విద్యుత్",
  [LangKeys.cat_water]: "నీటి బిల్లు",
  [LangKeys.cat_internet]: "టెలిఫోన్ / ఇంటర్నెట్",
  [LangKeys.cat_office]: "కార్యాలయ ఖర్చులు",
  [LangKeys.cat_marketing]: "మార్కెటింగ్ / ప్రకటనలు",
  [LangKeys.cat_travel]: "ప్రయాణం",
  [LangKeys.cat_fuel]: "ఇంధనం / పెట్రోల్",
  [LangKeys.cat_food]: "ఆహారం / అల్పాహారం",
  [LangKeys.cat_repairs]: "మరమ్మతులు మరియు నిర్వహణ",
  [LangKeys.cat_election]: "ఎన్నికల ఖర్చులు",
  [LangKeys.cat_taxes]: "పన్నులు / GST",
  [LangKeys.cat_insurance]: "భీమా",
  [LangKeys.cat_cleaning]: "శుభ్రత",
  [LangKeys.cat_delivery]: "డెలివరీ / షిప్పింగ్",
  [LangKeys.cat_software]: "సాఫ్ట్‌వేర్ / యాప్స్",
  [LangKeys.cat_furniture]: "ఫర్నిచర్",
  [LangKeys.cat_other]: "ఇతరులు",

  // ================= EXPENSE EMPTY STATE =================
  [LangKeys.expense_empty_title]: "మీ ఖర్చులను సులభంగా నిర్వహించండి",
  [LangKeys.expense_empty_subtitle]: "మీ వ్యాపారంలోని అన్ని ఖర్చులను ఒకే చోట ట్రాక్ చేయండి.",
  [LangKeys.expense_empty_footer]: "అన్ని ఖర్చులు ఆటోమేటిక్‌గా క్యాష్‌బుక్‌లో చేరతాయి.",

  // ================= BILL REPORT SCREEN =================
  [LangKeys.bill_report_title]: "బిల్ నివేదిక",
  [LangKeys.report_for_period]: "ఈ కాలానికి నివేదిక",
  [LangKeys.select_date_range]: "తేదీ పరిధిని ఎంచుకోండి",
  [LangKeys.total_sales]: "మొత్తం అమ్మకాలు",
  [LangKeys.total_purchases]: "మొత్తం కొనుగోలు",
  [LangKeys.total_expenses]: "మొత్తం ఖర్చులు",
  [LangKeys.net_profit]: "నికర లాభం",
  [LangKeys.net_loss]: "నికర నష్టం",
  [LangKeys.all_transactions]: "అన్ని లావాదేవీలు",
  [LangKeys.no_transactions_found_period]: "ఈ కాలంలో ఎలాంటి లావాదేవీలు లభించలేదు",
  [LangKeys.expense_fallback_category]: "ఇతర ఖర్చులు",

  // ================= SALES REPORT SCREEN =================
  [LangKeys.sales_report]: "అమ్మకాల నివేదిక",
  [LangKeys.transactions]: "లావాదేవీలు",
  [LangKeys.net_sale]: "నికర అమ్మకాలు",
  [LangKeys.unpaid_balance]: "బాకీ మొత్తం",
  [LangKeys.sales_report_share_text]: "ఇది మీ అమ్మకాల నివేదిక యొక్క సారాంశం.",

  // ================= PURCHASE REPORT SCREEN =================
  [LangKeys.purchase_report]: "కొనుగోలు నివేదిక",
  [LangKeys.net_purchase]: "నికర కొనుగోలు",
  [LangKeys.purchase_report_share_text]: "ఇది మీ కొనుగోలు నివేదిక యొక్క సారాంశం.",

  // ================= KHATA FILTER & SORT =================
  [LangKeys.filter_by_balance]: "మిగిలిన మొత్తాన్ని ఆధారంగా వడపోసుకోండి",
  [LangKeys.filter_all_parties]: "అన్ని పక్షాలు",

  // ================= LOGOUT =================
  [LangKeys.logout_confirm]: "మీరు నిజంగా లాగ్ అవుట్ కావాలనుకుంటున్నారా?",
  [LangKeys.confirm_logout]: "లాగ్ అవుట్",

  // ================= DEVICES =================
  [LangKeys.manage_devices]: "పరికరాలను నిర్వహించండి",
  [LangKeys.active_devices]: "సక్రియ పరికరాలు",
  [LangKeys.logout_device]: "పరికరాన్ని లాగ్ అవుట్ చేయండి",
  [LangKeys.logout_device_confirm]: "ఈ పరికరాన్ని లాగ్ అవుట్ చేయాలనుకుంటున్నారా?",
  [LangKeys.device_logged_out]: "పరికరం విజయవంతంగా లాగ్ అవుట్ అయింది",
  [LangKeys.no_active_devices]: "ఏ సక్రియ పరికరాలు లేవు",
  [LangKeys.last_login]: "చివరి లాగిన్",
  [LangKeys.this_device]: "ఈ పరికరం",
  [LangKeys.loading_devices]: "పరికరాలు లోడ్ అవుతున్నాయి...",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.send_whatsapp_messages]: "వాట్సాప్ సందేశాలను పంపించడం",
  [LangKeys.enabled]: "ఆన్",
  [LangKeys.disabled]: "ఆఫ్",
  [LangKeys.manage_whatsapp_settings]: "వాట్సాప్ SMS సెట్టింగులను నిర్వహించండి",
  [LangKeys.recharge_and_control]: "క్రెడిట్లను రీచార్జ్ చేసి సందేశాలను నియంత్రించండి",
  [LangKeys.wa_message_failed]: "సందేశం పంపడంలో విఫలమైంది",
  [LangKeys.wa_no_credits]: "క్రెడిట్లు ముగిశాయి, సందేశం పంపబడలేదు",


  // DASHBOARD EMPTY STATE
  [LangKeys.pro_tip]: "ప్రో టిప్",
  [LangKeys.dashboard_empty_tip]: "పూర్తి వివరాలను చూడటానికి, సవరించడానికి లేదా కస్టమర్లతో పంచుకోవడానికి ఎడమ వైపున ఉన్న ఏదైనా ఎంట్రీపై క్లిక్ చేయండి.",
  [LangKeys.select_entry]: "ఎంట్రీని ఎంచుకోండి",
  [LangKeys.entry_details_appear]: "ఎంట్రీ వివరాలు ఇక్కడ కనిపిస్తాయి",

  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "వ్యాపార నివేదికలు",
  [LangKeys.business_reports_desc]: "మీ వ్యాపారం కోసం విశ్లేషణలు మరియు అంతర్దృష్టులు",
  [LangKeys.ledger_cashbook_reports]: "లెడ్జర్ & క్యాష్‌బుక్ నివేదికలు",
  [LangKeys.billing_inventory_reports]: "బిల్లింగ్ & ఇన్వెంటరీ నివేదికలు",
  [LangKeys.customer_ledger_statement_report]: "కస్టమర్ లెడ్జర్ నివేదిక",
  [LangKeys.customer_ledger_report_desc]: "కస్టమర్ల కోసం వివరణాత్మక లావాదేవీల చరిత్ర మరియు బ్యాలెన్స్",
  [LangKeys.supplier_ledger_statement_report]: "సప్లయర్ లెడ్జర్ నివేదిక",
  [LangKeys.supplier_ledger_report_desc]: "సప్లయర్ల కోసం వివరణాత్మక లావాదేవీల చరిత్ర మరియు బ్యాలెన్స్",
  [LangKeys.cashbook_report_desc]: "నగదు మరియు ఆన్‌లైన్ ఎంట్రీల కోసం రోజువారీ వివరణ",
  [LangKeys.sales_report_desc]: "బిల్లుల వారీగా అమ్మకాల సారాంశం మరియు బ్యాలెన్స్",
  [LangKeys.purchase_report_desc]: "బిల్లుల వారీగా కొనుగోలు రికార్డులు మరియు సారాంశాలు",
  [LangKeys.bills_summary_report]: "బిల్లుల సారాంశ నివేదిక",
  [LangKeys.bills_summary_report_desc]: "అమ్మకాలు, కొనుగోళ్లు మరియు లాభ-నష్టాల విశ్లేషణ",
  [LangKeys.item_stock_sales_report]: "ఐటమ్ స్టాక్ & సేల్స్ నివేదిక",
  [LangKeys.item_stock_sales_report_desc]: "ఉత్పత్తులు మరియు సేవల కోసం స్టాక్ మరియు సేల్స్ సారాంశం",
  [LangKeys.select_party]: "పార్టీని ఎంచుకోండి",
  [LangKeys.search_placeholder]: "పేరు లేదా మొబైల్ ద్వారా వెతకండి...",
  [LangKeys.back_to_dashboard]: "రిపోర్ట్స్ మెనూకు తిరిగి వెళ్ళండి",
  [LangKeys.loading_report_data]: "రిపోర్ట్ డేటా లోడ్ అవుతోంది...",
  [LangKeys.no_parties_found]: "ఎలాంటి పార్టీలు లభించలేదు.",
  [LangKeys.select_customer]: "రిపోర్ట్ చూడటానికి కస్టమర్‌ని ఎంచుకోండి",
  [LangKeys.select_supplier]: "రిపోర్ట్ చూడటానికి సప్లయర్‌ని ఎంచుకోండి",
  [LangKeys.premium_feature]: "ప్రీమియం ఫీచర్",
  [LangKeys.premium_lock_desc]: "ప్రొఫెషనల్ బిల్లింగ్, సేల్స్/పర్చేజ్ ఇన్వాయిస్ రిపోర్ట్‌లు, డేబుక్ స్టేట్‌మెంట్‌లు మరియు ఇన్వెంటరీ సారాంశాలను అన్‌లాక్ చేయండి.",
  [LangKeys.upgrade_to_premium]: "యాడ్స్ ఫ్రీ+ / ప్రీమియమ్‌కు అప్‌గ్రేడ్ చేయండి 🚀",
  // PREMIUM
  [LangKeys.plan_standard_name]: "స్టాండర్డ్ (ప్రకటనలు లేని)",
  [LangKeys.plan_ads_free_name]: "ప్రకటనలు లేని +",
  [LangKeys.plan_premium_name]: "ప్రీమియం",
  [LangKeys.plan_recommended_tag]: "సిఫార్సు చేసిన ప్లాన్",
  [LangKeys.plan_duration_30_days]: "30 రోజుల కోసం",
  [LangKeys.plan_duration_180_days]: "180 రోజుల కోసం (6 నెలలు)",
  [LangKeys.plan_duration_365_days]: "365 రోజుల కోసం (1 సంవత్సరం)",
  [LangKeys.plan_duration_30_days_badge]: "30 రోజులు",
  [LangKeys.plan_save_20_percent]: "పొదుపు ~20%",
  [LangKeys.plan_best_value_badge]: "ఉత్తమ విలువ",
  [LangKeys.plan_best_value_plan_tag]: "ఉత్తమ విలువ ప్లాన్",
  [LangKeys.plan_most_popular_save]: "అత్యంత ప్రజాదరణ • ₹{amount} ఆదా",
  [LangKeys.plan_save_amount_tag]: "₹{amount} ఆదా",
  [LangKeys.duration_1_month]: "1 నెల",
  [LangKeys.duration_6_months]: "6 నెలలు",
  [LangKeys.duration_12_months]: "12 నెలలు",
  [LangKeys.plan_save_text]: "సేవ్ చేయండి",
  [LangKeys.benefit_no_ads]: "ప్రకటనలు లేవు (100% ప్రకటనలు లేని అనుభవం)",
  [LangKeys.benefit_support]: "24/7 ప్రాధాన్య కస్టమర్ సహాయం",
  [LangKeys.benefit_all_ads_free]: "Ads Free + ప్లాన్ యొక్క అన్ని ప్రయోజనాలు",
  [LangKeys.benefit_multiple_devices]: "ఒకేసారి అనేక పరికరాల్లో లాగిన్ అవ్వండి",
  [LangKeys.benefit_desktop_access]: "కంప్యూటర్/డెస్క్‌టాప్‌లో యాక్సెస్",
  [LangKeys.benefit_create_bills]: "బిల్లులు సృష్టించండి (సాధారణ బిల్లులు, GST బిల్లులు)",
  [LangKeys.benefit_defaulters_list]: "ఒక క్లిక్‌తో డిఫాల్టర్ల జాబితాను చూడండి",
  [LangKeys.benefit_organize_lists]: "జాబితాలతో మీ ఖాతాలను నిర్వహించండి",
  [LangKeys.benefit_manage_stocks]: "స్టాక్స్ నిర్వహించండి (లావాదేవీలతో ఐటెంలను జోడించండి)",
  [LangKeys.benefit_financial_reports]: "ప్రీమియం ఆర్థిక నివేదికలు (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "సురక్షిత లోకల్ మరియు క్లౌడ్ స్టోరేజ్‌లో డ్యూయల్ బ్యాకప్",
  [LangKeys.benefit_unlimited_entry]: "క్యాష్‌బుక్/ఖాతాలో అపరిమిత ఎంట్రీలు",
  [LangKeys.benefit_unlimited_transactions]: "అపరిమిత లావాదేవీలు (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "అపరిమిత SMS",
  [LangKeys.benefit_dairy_management]: "డెయిరీ సౌకర్యాలు (పాల రికార్డులు, రేట్ చార్ట్‌లు, బిల్లులు)",
  [LangKeys.benefit_refer_earn]: "రిఫర్ చేయండి మరియు సంపాదించండి (ఉచిత రీఛార్జ్ చెల్లుబాటు)",
  [LangKeys.my_subscription_title]: "నా సభ్యత్వం",
  [LangKeys.premium_plans_title]: "మా ప్రీమియం ప్లాన్లు",
  [LangKeys.active_badge_label]: "క్రియాశీలకం",
  [LangKeys.expires_on_label]: "గడువు ముగింపు తేదీ {date}",
  [LangKeys.expired_badge_label]: "గడువు ముగిసింది",
  [LangKeys.expired_on_label]: "{date} న గడువు ముగిసింది",
  [LangKeys.extend_plan_label]: "ప్లాన్‌ను పొడిగించండి (+{days} రోజులు)",
  [LangKeys.days_remaining_label]: "({days} రోజులు మిగిలి ఉన్నాయి)",
  [LangKeys.secure_checkout_label]: "100% సురక్షిత SSL చెల్లింపు",
  [LangKeys.upgrade_button]: "అప్‌గ్రేడ్ చేయండి",
  [LangKeys.downgrade_button]: "డౌన్‌గ్రేడ్ చేయండి",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ఆన్‌లైన్ స్టోర్ సెట్టింగ్‌లు (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ఆన్‌లైన్ వ్యాపారాన్ని ఆన్‌లో ఉంచండి',
  [LangKeys.biz_profile__online_business_active]: 'వ్యాపారం ఆన్‌లైన్‌లో సక్రియంగా ఉంది (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'వ్యాపారం ఆన్‌లైన్‌లో నిలిపివేయబడింది (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ఆన్‌లైన్‌లో సక్రియంగా ఉంది (GPS సెట్ చేయండి)',
  [LangKeys.biz_profile__online_business_sub_active]: 'ఆన్ చేసిన తర్వాత 1-క్లిక్‌తో రాష్ట్రం, నగరం, ప్రాంతం మరియు పిన్‌కోడ్‌ను ఆటో-ఫిల్ చేసి GPS సెట్ చేయండి, తద్వారా మీ దుకాణం కస్టమర్‌లకు కనిపిస్తుంది.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'స్థానిక మార్కెట్‌లో సమీపంలోని కస్టమర్‌లు మీ ఉత్పత్తులు మరియు సేవలను కనుగొనడానికి ఆన్‌లైన్ వ్యాపారాన్ని ఆన్ చేయండి.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 దీని ప్రయోజనాలు & నియమాలను తెలుసుకోండి',
  [LangKeys.biz_profile__benefits_modal_title]: 'ఆన్‌లైన్ వ్యాపారం యొక్క ప్రయోజనాలు & పూర్తి సమాచారం',
  [LangKeys.biz_profile__benefits_step1_title]: '1. దీన్ని ఆన్ చేయడం వల్ల ఏమి జరుగుతుంది?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'మీ వ్యాపారం, ఉత్పత్తులు మరియు సేవలు వెంటనే లోకల్ మార్కెట్‌లో ప్రత్యక్ష ప్రసారమవుతాయి. సమీప కస్టమర్‌లు మిమ్మల్ని సంప్రదించవచ్చు.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. మీరు ఏమి చేయాలి?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• నీలం బటన్ (⚡ 1-క్లిక్) ఉపయోగించి చిరునామా మరియు GPSని ఆటో-ఫిల్ చేయండి.\n• మీ ఉత్పత్తులు లేదా సేవలను జోడించండి.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. ఎలాంటి ప్రయోజనాలు లభిస్తాయి?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% కమీషన్ (100% ఉచితం) — మధ్యవర్తులు లేరు.\n• కస్టమర్ల నుండి నేరుగా WhatsApp మరియు కాల్‌లో ఆర్డర్‌లను పొందండి.\n• 24 గంటలూ తెరిచి ఉండే డిజిటల్ దుకాణం.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'అర్థమైంది, ధన్యవాదాలు 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-క్లిక్‌లో పూర్తి చిరునామాను ఆటో-ఫిల్ చేయండి',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS ద్వారా రాష్ట్రం, నగరం, ప్రాంతం, పిన్‌కోడ్ ఆటోమేటిక్‌గా నింపబడుతుంది',
  [LangKeys.biz_profile__autofill_searching]: 'స్థానాన్ని కనుగొంటోంది...',
  [LangKeys.biz_profile__state_lbl]: 'రాష్ట్రం (State)',
  [LangKeys.biz_profile__state_add]: 'రాష్ట్రాన్ని జోడించండి',
  [LangKeys.biz_profile__state_placeholder]: 'ఉదా. Telangana, Andhra Pradesh...',
  [LangKeys.biz_profile__city_lbl]: 'నగరం / జిల్లా (City / District)',
  [LangKeys.biz_profile__city_add]: 'నగరాన్ని జోడించండి',
  [LangKeys.biz_profile__city_placeholder]: 'ఉదా. Hyderabad, Vijayawada, Visakhapatnam...',
  [LangKeys.biz_profile__area_lbl]: 'ప్రాంతం / గ్రామం (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'ప్రాంతాన్ని జోడించండి',
  [LangKeys.biz_profile__area_placeholder]: 'ఉదా. Banjara Hills, Madhapur, Benz Circle...',
  [LangKeys.biz_profile__pincode_lbl]: 'పిన్‌కోడ్ (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'పిన్‌కోడ్‌ను జోడించండి',
  [LangKeys.biz_profile__pincode_placeholder]: '6 అంకెల పిన్‌కోడ్‌ను నమోదు చేయండి',
  [LangKeys.biz_profile__tagline_lbl]: 'వ్యాపార ట్యాగ్‌లైన్ / వివరణ',
  [LangKeys.biz_profile__tagline_add]: 'ట్యాగ్‌లైన్‌ను జోడించండి',
  [LangKeys.biz_profile__tagline_placeholder]: 'ఉదా. మా వద్ద తాజా నాణ్యమైన వస్తువులు లభిస్తాయి',
  [LangKeys.biz_profile__gps_lbl]: 'వ్యాపార GPS స్థానం',
  [LangKeys.biz_profile__gps_not_set]: 'స్థానం ఇంకా సెట్ చేయబడలేదు',
  [LangKeys.biz_profile__gps_update_btn]: 'నవీకరించండి',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS స్థానాన్ని పొందండి',
  [LangKeys.biz_profile__gps_searching]: 'వెతుకుతోంది...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ స్టోర్ ఆన్‌లైన్‌లో ఉంది కానీ GPS సెట్ చేయలేదు! కస్టమర్‌లకు దుకాణం కనిపించడానికి ⚡ 1-క్లిక్ ద్వారా GPS సెట్ చేయండి.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'బ్రౌజర్‌లో GPS / Locationను ఆన్ చేయండి',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'స్థాన అనుమతి నిరాకరించబడింది',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'సెట్టింగ్‌లలో Location Permissionను ఆన్ చేయండి',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS ద్వారా పూర్తి చిరునామా ఆటోమేటిక్‌గా నింపబడింది!',
  [LangKeys.biz_profile__gps_error_toast]: 'స్థానాన్ని పొందడంలో లోపం సంభవించింది',
  [LangKeys.biz_market_video_guide_title]: 'లోకల్ మార్కెట్‌లో దుకాణాన్ని ఆన్‌లైన్ ఎలా చేయాలి?',
  [LangKeys.biz_market_video_guide_sub]: '1 నిమిషం వీడియో గైడ్ చూడండి • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "స్టోర్ మరియు ఉత్పత్తులను ఆన్‌లైన్‌లో యాక్టివేట్ చేయడానికి గైడ్",
  [LangKeys.service_video_guide_btn_sub]: "పని మరియు దుకాణాన్ని ఆన్‌లైన్‌లో లిస్ట్ చేయడానికి గైడ్",
  [LangKeys.item_marketplace_title]: "ఆన్‌లైన్ మార్కెట్‌ప్లేస్ (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "ఈ ప్రోడక్ట్ వినియోగదారులకు ఆన్‌లైన్‌లో కనిపిస్తుంది, వారు మిమ్మల్ని నేరుగా సంప్రదించవచ్చు మరియు WhatsAppలో ఆర్డర్ చేయవచ్చు.",
  [LangKeys.item_marketplace_sub_inactive]: "ఈ ఉత్పత్తి మీ వ్యక్తిగత ఖాతాలో మాత్రమే ఉంటుంది.",
  [LangKeys.service_marketplace_sub_active]: "ఈ సేవ వినియోగదారులకు ఆన్‌లైన్‌లో కనిపిస్తుంది, వారు మిమ్మల్ని నేరుగా సంప్రదించవచ్చు మరియు WhatsApp/కాల్ ద్వారా బుక్ చేసుకోవచ్చు.",
  [LangKeys.service_marketplace_sub_inactive]: "ఈ సేవ మీ దుకాణం వ్యక్తిగత ఖాతాలో మాత్రమే ఉంటుంది.",
  [LangKeys.item_category_lbl]: "వర్గం (Category)",
  [LangKeys.change_btn]: "మార్చండి",
  [LangKeys.item_discount_price_lbl]: "ఆఫర్ / డిస్కౌంట్ ధర (₹) (ఐచ్ఛికం)",
  [LangKeys.item_discount_price_hint]: "ఉదా. 450",
  [LangKeys.service_discount_price_lbl]: "ఆఫర్ / డిస్కౌంట్ సర్వీస్ ఛార్జ్ (₹) (ఐచ్ఛికం)",
  [LangKeys.service_discount_price_hint]: "ఉదా. 750",
  [LangKeys.item_desc_lbl]: "వివరణ (Short Description) (ఐచ్ఛికం)",
  [LangKeys.item_desc_hint]: "ఉత్పత్తి బ్రాండ్, మోడల్, రంగు, పరిమాణం & ముఖ్య ఫీచర్లను నమోదు చేయండి...",
  [LangKeys.service_desc_lbl]: "సేవా వివరణ (ఐచ్ఛికం)",
  [LangKeys.service_desc_hint]: "సేవా ఫీచర్లు, పని విధానం మరియు అనుభవాన్ని నమోదు చేయండి...",
  [LangKeys.market_seo_badge]: "గూగుల్ సెర్చ్ & ర్యాంకింగ్",
  [LangKeys.category_picker_title]: "వర్గాన్ని ఎంచుకోండి",
  [LangKeys.category_picker_sub_item]: "వస్తువు ఏ వర్గానికి చెందినది?",
  [LangKeys.category_picker_sub_service]: "సేవ ఏ వర్గానికి చెందినది?",
  [LangKeys.category_search_hint]: "వర్గాన్ని శోధించండి (ఉదా. కిరాణా, పాలు, బట్టలు...)",
  [LangKeys.no_category_found]: "ఎలాంటి వర్గం కనుగొనబడలేదు",
  [LangKeys.nothing_found_for]: "కోసం ఏమీ కనుగొనబడలేదు",
  [LangKeys.cat_title_general]: "సాధారణ ఉత్పత్తులు",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "కిరాణా, రేషన్ & ప్రొవిజన్స్",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "డైరీ, పాలు, నెయ్యి & పన్నీర్",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "పండ్లు & తాజా కూరగాయలు",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "స్వీట్స్, బేకరీ & స్నాక్స్",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "హోటల్, ధాబా & రెస్టారెంట్",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "మెడికల్ & హెల్త్‌కేర్",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "వ్యవసాయం, ఎరువులు & విత్తనాలు",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "పశుగ్రాసం & ఫీడ్",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "మొబైల్స్, ల్యాప్‌టాప్స్ & కంప్యూటర్స్",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "ఎలక్ట్రికల్స్ & గృహోపకరణాలు",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "బట్టలు, చీరలు & రెడీమేడ్",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "చెప్పులు & బూట్లు",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "హార్డ్‌వేర్, శానిటరీ & టూల్స్",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "భవన నిర్మాణ సామగ్రి & సిమెంట్",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ఆటో పార్ట్స్ & స్పేర్స్",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "కాస్మెటిక్స్, బ్యూటీ & సెలూన్",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "పుస్తకాలు, స్టేషనరీ & ప్రింటింగ్",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "బంగారం, వెండి & నగలు",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "ఫర్నిచర్ & హోమ్ డెకర్",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "వంట పాత్రలు & కిచెన్‌వేర్",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "బొమ్మలు & స్పోర్ట్స్",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "ప్లాస్టిక్ & ప్యాకేజింగ్ సామగ్రి",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "టైలరింగ్ & బోటిక్",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "మాంసం, చేపలు & చికెన్",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "రిపేరింగ్ & సేవల విభాగం",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "ఇతర వస్తువులు & సేవలు",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "కళ్లద్దాలు & ఆప్టికల్స్",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "పూజా సామాగ్రి & అగరబత్తులు",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "వాచీలు & ఉపకరణాలు",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "సాధారణ సేవ (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "టీవీ & ఎలక్ట్రానిక్స్ రిపేరింగ్",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "ఏసీ, ఫ్రిజ్, వాషింగ్ మెషీన్ సర్వీస్",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "ఎలక్ట్రీషియన్ & వైరింగ్",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "ప్లంబర్ & శానిటరీ ఫిట్టింగ్",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "కుట్లు & టైలరింగ్ సేవలు",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "మొబైల్, ల్యాప్‌టాప్ సర్వీస్",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "కార్, బైక్ మెకానిక్ & వాషింగ్",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "బ్యూటీ పార్లర్ & సెలూన్",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "వడ్రంగి / కార్పెంటర్ పని",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "పెయింటింగ్ & సున్నం వేయుట",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "భవన నిర్మాణం & తాపీ పని",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ట్రాక్టర్ & మోటార్ పంప్ రిపేర్",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "సీసీటీవీ కెమెరా ఫిట్టింగ్",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "క్లీనింగ్ & పెస్ట్ కంట్రోల్",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "రవాణా, లోడింగ్ & షిఫ్టింగ్",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "ఫోటోగ్రఫీ & వీడియోగ్రఫీ",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "ఈవెంట్స్, కేటరింగ్ & డీజే సౌండ్",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "ట్యూషన్లు & విద్యా క్లాసులు",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "టాక్స్, మీసేవ & ఆన్‌లైన్ సేవలు",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "డాక్టర్, క్లినిక్ & ల్యాబ్ టెస్టులు",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "ఇతర నైపుణ్య సేవలు",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "టాక్సీ & టూర్ ట్రావెల్స్",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "న్యాయవాది & చట్టపరమైన సేవలు",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "ప్యాకర్స్ & మూవర్స్",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "ప్రింటింగ్ & ఫ్లెక్స్ బ్యానర్లు",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "జిమ్, ఫిట్‌నెస్ & యోగా",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "వంట మనుషులు & గృహ సహాయకులు",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "ఫోటో జోడించబడింది • Tier-1 అగ్ర జాబితా",
  [LangKeys.item_photo_guide_why_add]: "ఫోటో ఎందుకు జోడించాలి? (5x ఎక్కువ అమ్మకాలు)",
  [LangKeys.service_photo_guide_why_add]: "ఫోటో ఎందుకు జోడించాలి? (5x ఎక్కువ బుకింగ్స్)",
  [LangKeys.item_photo_guide_desc]: "స్పష్టమైన PNG/JPG ఫోటోలను జోడించండి. ఫోటోలు ఉన్న ఉత్పత్తులు ఆన్‌లైన్ మార్కెట్‌లో అగ్రస్థానంలో (Tier-1) కనిపిస్తాయి.",
  [LangKeys.service_photo_guide_desc]: "మీ పని, పరికరాలు లేదా దుకాణం యొక్క స్పష్టమైన ఫోటోలను జోడించండి. ఫోటోలు ఉన్న సేవలు సమీప వినియోగదారులకు అగ్రస్థానంలో (Tier-1) కనిపిస్తాయి.",
  [LangKeys.item_video_guide_btn_title]: "ఆన్‌లైన్ లిస్టింగ్ నేర్చుకోండి (5 నిమిషాల వీడియో)",
  [LangKeys.service_video_guide_btn_title]: "సర్వీస్ లిస్టింగ్ నేర్చుకోండి (5 నిమిషాల వీడియో)",
  [LangKeys.market_format_bold]: "𝗕 బోల్డ్ (*పేరు*)",
  [LangKeys.market_format_bullet]: "• బుల్లెట్ పాయింట్",
  [LangKeys.market_format_highlight]: "⭐ ముఖ్య విశేషాలు",
  [LangKeys.market_format_warranty_item]: "📦 వారంటీ / వివరాలు",
  [LangKeys.market_format_warranty_service]: "📦 వారంటీ / గ్యారెంటీ",
  [LangKeys.market_format_template_item]: "⚡ రెడీ బ్లాగ్ టెంప్లేట్",
  [LangKeys.market_format_template_service]: "⚡ రెడీ సర్వీస్ టెంప్లేట్",
  [LangKeys.market_seo_tip_item]: "వివరమైన వివరణ రాయడం వల్ల మీ ఉత్పత్తి గూగుల్ సెర్చ్ మరియు ఆన్‌లైన్ మార్కెట్‌లో వేగంగా కనిపిస్తుంది.",
  [LangKeys.market_seo_tip_service]: "వివరమైన వివరణ రాయడం వల్ల మీ సేవ గూగుల్ సెర్చ్ మరియు ఆన్‌లైన్ మార్కెట్‌లో వేగంగా కనిపిస్తుంది.",
  [LangKeys.crop_photo_title]: "ఫోటోను క్రాప్ మరియు సర్దుబాటు చేయండి",
  [LangKeys.crop_product_photo]: "ఉత్పత్తి ఫోటోను క్రాప్ చేయండి",
  [LangKeys.crop_service_photo]: "సర్వీస్ ఫోటోను క్రాప్ చేయండి",
  [LangKeys.crop_drag_hint]: "ఫోటోను తరలించడానికి లాగండి",
  [LangKeys.crop_rotate_left]: "90° ఎడమ",
  [LangKeys.crop_rotate_right]: "90° కుడి",
  [LangKeys.crop_reset]: "రీసెట్",
  [LangKeys.crop_ratio_square]: "1:1 (చతురస్రం)",
  [LangKeys.crop_ratio_standard]: "4:3 (ప్రామాణికం)",
  [LangKeys.crop_ratio_free]: "Free (ఉచిత)",
  [LangKeys.crop_save_done]: "క్రాప్ చేసి సేవ్ చేయండి (Done)",
  [LangKeys.crop_compressing]: "కుదిస్తోంది...",
  [LangKeys.party_or_details]: "పార్టీ / వివరాలు",
  [LangKeys.report_copied_clipboard]: "నివేదిక సారాంశం క్లిప్‌బోర్డ్‌కి కాపీ చేయబడింది!",
  [LangKeys.party]: "పార్టీ",
  [LangKeys.sale]: "అమ్మకం",
  [LangKeys.purchase]: "కొనుగోలు",
  [LangKeys.expense]: "ఖర్చు",
  [LangKeys.ai_support_btn]: "AI మద్దతుతో వెంటనే చాట్ చేయండి (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI మద్దతు",
  [LangKeys.ai_support_online_status]: "● 24x7 తక్షణ సహాయం",
  [LangKeys.ai_support_welcome_msg]: "నమస్తే! 🙏 నేను *Moxpal Khata* యొక్క స్మార్ట్ AI అసిస్టెంట్‌ని.\\n\\nమీ ఖాతా, బిల్లింగ్, డెయిరీ పాస్‌బుక్ లేదా చందా ప్లాన్‌కు సంబంధించిన అన్ని ప్రశ్నలలో సహాయం చేయడానికి నేను సిద్ధంగా ఉన్నాను. మీరు ఏమి తెలుసుకోవాలనుకుంటున్నారు?",
  [LangKeys.ai_support_input_hint]: "మీ ప్రశ్న లేదా సమస్యను ఇక్కడ అడగండి...",
  [LangKeys.ai_support_typing]: "AI సహాయకుడు సమాధానం రాస్తున్నారు...",
  [LangKeys.ai_support_copied]: "సందేశం కాపీ చేయబడింది",
  [LangKeys.ai_support_net_error]: "ఇంటర్నెట్ కనెక్షన్‌లో సమస్య ఉంది. దయచేసి నెట్‌వర్క్ తనిఖీ చేయండి.",
  [LangKeys.ai_support_server_error]: "సర్వర్‌తో కనెక్ట్ చేయడంలో సమస్య ఏర్పడింది. దయచేసి మళ్లీ ప్రయత్నించండి లేదా WhatsApp ద్వారా సంప్రదించండి.",
  [LangKeys.ai_support_sugg_plan]: "💎 ప్లాన్ ప్రయోజనాలు ఏమిటి?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 డెయిరీ పాస్‌బుక్‌ని ఎలా ఉపయోగించాలి?",
  [LangKeys.ai_support_sugg_party]: "👥 కొత్త కస్టమర్/ఖాతాను ఎలా జోడించాలి?",
  [LangKeys.ai_support_sugg_backup]: "💾 డేటా బ్యాకప్ ఎలా తీసుకోవాలి?",
  [LangKeys.ai_support_sugg_bill]: "🧾 కొత్త బిల్లును ఎలా సృష్టించాలి?",
  [LangKeys.ai_support_clear_chat]: "కొత్త చాట్ ప్రారంభించండి",
  [LangKeys.ai_support_clear_title]: "చాట్ హిస్టరీని క్లియర్ చేయాలా?",
  [LangKeys.ai_support_clear_confirm]: "మీరు పాత చాట్‌ను క్లియర్ చేసి కొత్త చాట్ ప్రారంభించాలనుకుంటున్నారా?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "తరచుగా అడిగే ప్రశ్నలు, ట్యుటోరియల్స్ మరియు కస్టమర్ సపోర్ట్ కేంద్రం",
  [LangKeys.help_support_title]: "సహాయం మరియు మద్దతు",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, ట్యుటోరియల్స్ మరియు కస్టమర్ సపోర్ట్ కోసం మీ వన్-స్టాప్ సెంటర్",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 తక్షణ మద్దతు",
  [LangKeys.help_ai_desc]: "ఖాతా, బిల్లింగ్, ఇన్వెంటరీ, డెయిరీ పాస్‌బుక్ లేదా ప్లాన్‌లకు సంబంధించిన అన్ని ప్రశ్నలకు తక్షణ AI పరిష్కారాలను పొందండి.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • అధికారిక మద్దతు బృందం",
  [LangKeys.help_call_title]: "కాల్ హెల్ప్‌లైన్",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "ఇమెయిల్ మద్దతు",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "తరచుగా అడిగే ప్రశ్నలు (FAQs)",
  [LangKeys.help_faq_1_q]: "ఖాతాలో కొత్త కస్టమర్ లేదా సరఫరాదారుని ఎలా జోడించాలి?",
  [LangKeys.help_faq_1_a]: "హోమ్ స్క్రీన్‌పై \"Add Customer\" బటన్‌ను నొక్కండి, పేరు మరియు మొబైల్ నంబర్‌ను నమోదు చేసి సేవ్ చేయండి.",
  [LangKeys.help_faq_2_q]: "డెయిరీ పాస్‌బుక్‌లో పాల సేకరణ ఎంట్రీని ఎలా నమోదు చేయాలి?",
  [LangKeys.help_faq_2_a]: "డెయిరీ విభాగానికి వెళ్లి, \"పాల ఎంట్రీ\"ని ఎంచుకోండి, ఫ్యాట్/SNF లేదా డైరెక్ట్ రేటును నమోదు చేసి 1-క్లిక్‌తో రశీదు పంపండి.",
  [LangKeys.help_faq_3_q]: "డేటా బ్యాకప్ ఎలా సురక్షితంగా ఉంటుంది?",
  [LangKeys.help_faq_3_a]: "మోక్స్‌పాల్ ఖాతాలో మీ మొత్తం డేటా క్లౌడ్ సర్వర్‌లో 100% ఎన్‌క్రిప్ట్ చేయబడి సురక్షితంగా ఉంటుంది.",
  [LangKeys.help_faq_4_q]: "సబ్‌స్క్రిప్షన్ ప్లాన్‌ను ఎలా అప్‌గ్రేడ్ చేయాలి?",
  [LangKeys.help_faq_4_a]: "సెట్టింగ్స్‌లో \"నా సబ్‌స్క్రిప్షన్\"కి వెళ్లి మీకు నచ్చిన ప్లాన్‌ను ఎంచుకుని సురక్షితంగా చెల్లింపు చేయండి.",
  [LangKeys.help_footer_call_hours]: "కాల్ సపోర్ట్: సోమ - శని (ఉదయం 9:00 నుండి రాత్రి 8:00 వరకు)",
  [LangKeys.help_footer_ai_hours]: "AI చాట్ అసిస్టెంట్: 24 గంటలు 365 రోజులు తక్షణ సహాయం",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% సురక్షితం & నమ్మదగినది • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "సేవను తెరవడం సాధ్యం కాలేదు",
};

export default te;